(function(){
  'use strict';
  if (window.__YF_NATIVE_DB_V70_EXACT_SKU_LOOKUP__) return;
  window.__YF_NATIVE_DB_V70_EXACT_SKU_LOOKUP__ = true;

  const esc = v => String(v == null ? '' : v).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const enc = v => encodeURIComponent(v == null ? '' : String(v));
  const norm = v => String(v || '').trim().toUpperCase().replace(/[\s\-\/\.]+/g, '');
  // Exact SKU lookup is intentionally stricter than part/model matching.
  // Trim/case-normalize only, so MD6-2 matches MD6-2 but not MD62 or MD6.
  const skuKey = v => String(v || '').trim().toUpperCase();
  const slug = v => String(v || '').toLowerCase().replace(/&/g,'and').replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'');
  const money = v => {
    if (v == null || v === '') return '';
    let raw = String(v).trim();
    let n = Number(raw.replace(/[^0-9.]/g,''));
    if (!Number.isFinite(n)) return raw;
    if (!raw.includes('.') && /^\d+$/.test(raw) && raw.length >= 3) n = n / 100;
    return '$' + n.toFixed(2);
  };
  const nativeSearchUrl = q => '/search?q=' + enc(q) + '&type=product&options%5Bprefix%5D=last';
  const partInfoUrl = id => '/search?yf_mode=part-number&id=' + enc(id || '');
  const diagramUrl = id => '/search?yf_mode=breakdowns&diagram=' + enc(id || '');
  const modelBreakdownUrl = m => '/search?yf_mode=breakdowns&model=' + enc(m || '');
  const deb = (fn, ms) => { let t; return function(){ clearTimeout(t); const a = arguments; t = setTimeout(() => fn.apply(this, a), ms); }; };
  const idle = fn => (window.requestIdleCallback ? window.requestIdleCallback(fn, {timeout: 900}) : setTimeout(fn, 40));
  async function mapLimit(items, limit, worker){
    items = items || [];
    const out = new Array(items.length);
    let cursor = 0;
    async function run(){
      while(cursor < items.length){
        const i = cursor++;
        out[i] = await worker(items[i], i);
      }
    }
    await Promise.all(Array.from({length: Math.min(limit || 8, items.length || 1)}, run));
    return out;
  }
  function bucket(k){ k = norm(k); if(!k) return 'OTHER'; const c = k[0]; if(/[0-9]/.test(c)) return c; if(/[A-Z]/.test(c)) return c; return 'OTHER'; }
  function pageModelQueryFromHandle(handle){
    let h = slug(handle || '');
    const marker = 'product-id-';
    const pos = h.indexOf(marker);
    if(pos < 0) return '';
    let q = h.slice(pos + marker.length);
    q = q
      .replace(/-parts-lists?$/g, '')
      .replace(/-parts-list$/g, '')
      .replace(/-parts$/g, '')
      .replace(/^-+|-+$/g, '');
    return q;
  }

  class DB {
    constructor(){
      this.manifest = null;
      this.manifestPromise = null;
      this.cache = {};
      this.pending = {};
      this.manifestUrl = (window.YF_NATIVE_DB && window.YF_NATIVE_DB.manifestUrl) || '/assets/yf-index-manifest.json';
    }
    async init(){
      if(this.manifest) return this.manifest;
      if(this.manifestPromise) return this.manifestPromise;
      this.manifestPromise = (async () => {
        const r = await fetch(this.manifestUrl, {credentials:'same-origin', cache:'force-cache'});
        if(!r.ok) throw new Error('Could not load native search manifest');
        this.manifest = await r.json();
        return this.manifest;
      })();
      try{ return await this.manifestPromise; }
      catch(e){ this.manifestPromise = null; throw e; }
    }
    url(file){ const u = new URL(this.manifestUrl, location.href); u.search = ''; const parts = u.pathname.split('/'); parts[parts.length-1] = file; u.pathname = parts.join('/'); return u.toString(); }
    async load(type,b){
      await this.init();
      const file = this.manifest.chunks && this.manifest.chunks[type] && this.manifest.chunks[type][b];
      if(!file) return {};
      const key = type + ':' + b;
      if(this.cache[key]) return this.cache[key];
      if(this.pending[key]) return this.pending[key];
      this.pending[key] = (async () => {
        try{
          const r = await fetch(this.url(file), {credentials:'same-origin', cache:'force-cache'});
          if(!r.ok) return {};
          return await r.json();
        }catch(e){ return {}; }
      })();
      const j = await this.pending[key];
      this.cache[key] = j || {};
      delete this.pending[key];
      return this.cache[key];
    }
    collection(){ return this.load('collection','ALL'); }
    supersessions(){ return this.load('supersession','ALL'); }
    categoryModels(){ return this.load('categoryModels','ALL'); }
    async model(q){ const k = norm(q); const ch = await this.load('model', bucket(k)); return ch[k] || null; }
    async part(q){ const k = norm(q); const ch = await this.load('part', bucket(k)); return ch[k] || null; }
    async productPart(q){ const k = norm(q); const ch = await this.load('product-part', bucket(k)); return ch[k] || null; }
    async sku(q){ const k = skuKey(q); if(!k) return []; const ch = await this.load('sku', 'ALL'); return (ch[k] || []).map(p => Object.assign({}, p)); }
    async loadAll(type){
      await this.init();
      const chunks = (this.manifest.chunks && this.manifest.chunks[type]) || {};
      const keys = Object.keys(chunks);
      const loaded = await Promise.all(keys.map(k => this.load(type, k)));
      return loaded.reduce((acc, item) => Object.assign(acc, item || {}), {});
    }
    async allParts(){ return this.loadAll('part'); }
    async diagram(id){ const ch = await this.load('diagram', bucket(id)); return ch[id] || null; }
    async modelDiagrams(modelKey){ const k = norm(modelKey); const ch = await this.load('model-diagrams', bucket(k)); return ch[k] || []; }
    async searchPrefix(type,q,limit){ const k = norm(q); if(!k) return []; const ch = await this.load(type, bucket(k)); const out = []; Object.keys(ch).some(key => { const rec = ch[key]; const hay = key + ' ' + norm(rec.m||'') + ' ' + norm(rec.p||'') + ' ' + norm(rec.d||''); if(key.startsWith(k) || hay.includes(k)){ out.push(rec); } return out.length >= (limit || 6); }); return out; }
  }
  const db = new DB();
  window.YFSearchDB = db;

  // V61: faster native database + browser-back restore cache. If a customer opens a product/diagram/collection
  // and then hits the browser Back button, restore the already-rendered native results
  // instantly instead of rebuilding the page and re-checking live Shopify products.
  const YF_PAGE_CACHE_VERSION = 'v70-exact-sku-lookup-20260625';
  const YF_PAGE_CACHE_PREFIX = 'yf-native-page-cache:';
  const YF_PAGE_CACHE_TTL = 45 * 60 * 1000;
  let yfPageCacheTimer = null;
  function nativePageCacheKey(){ return YF_PAGE_CACHE_PREFIX + YF_PAGE_CACHE_VERSION + ':' + location.pathname + location.search; }
  function nativeAppRootFrom(scope){ return (scope && scope.closest && scope.closest('[data-yf-native-app]')) || document.querySelector('[data-yf-native-app]'); }
  function nativeResultsFrom(scope){ const root = nativeAppRootFrom(scope); return root && root.querySelector('[data-yf-results]'); }
  function nativePageHasLoading(res){ return !!(res && res.querySelector('.yf-loading, .yf-products-loading')); }
  function pruneNativePageCache(){
    try{
      const keys = [];
      for(let i=0;i<sessionStorage.length;i++){ const k = sessionStorage.key(i); if(k && k.indexOf(YF_PAGE_CACHE_PREFIX) === 0) keys.push(k); }
      keys.sort((a,b)=>{
        try{ return (JSON.parse(sessionStorage.getItem(b)||'{}').createdAt||0) - (JSON.parse(sessionStorage.getItem(a)||'{}').createdAt||0); }catch(e){ return 0; }
      });
      keys.slice(12).forEach(k => sessionStorage.removeItem(k));
    }catch(e){}
  }
  function saveNativePageCache(scope, force){
    try{
      const root = nativeAppRootFrom(scope);
      const res = root && root.querySelector('[data-yf-results]');
      if(!root || !res) return;
      const html = (res.innerHTML || '').trim();
      if(!html) return;
      if(!force && nativePageHasLoading(res)) return;
      const item = {
        version: YF_PAGE_CACHE_VERSION,
        createdAt: Date.now(),
        path: location.pathname,
        search: location.search,
        scrollX: window.scrollX || 0,
        scrollY: window.scrollY || 0,
        breakdownMode: document.body.classList.contains('yf-breakdown-mode'),
        html: html
      };
      sessionStorage.setItem(nativePageCacheKey(), JSON.stringify(item));
      pruneNativePageCache();
    }catch(e){}
  }
  function scheduleNativePageCacheSave(scope, force){
    clearTimeout(yfPageCacheTimer);
    yfPageCacheTimer = setTimeout(function(){ saveNativePageCache(scope, force); }, 120);
  }
  function clearRestoredEventBindings(scope){
    try{
      scope.querySelectorAll('[data-yf-serial-picker][data-bound], [data-yf-ref-search][data-bound], .yf-callout-dot[data-bound], [data-yf-category-widget][data-bound]').forEach(el => el.removeAttribute('data-bound'));
      scope.querySelectorAll('[data-yf-collection-card][data-collection-safe-bound]').forEach(el => el.removeAttribute('data-collection-safe-bound'));
    }catch(e){}
  }
  function restoreNativePageCache(root, pageType){
    try{
      const res = root && root.querySelector('[data-yf-results]');
      if(!res) return false;
      const raw = sessionStorage.getItem(nativePageCacheKey());
      if(!raw) return false;
      const item = JSON.parse(raw);
      if(!item || item.version !== YF_PAGE_CACHE_VERSION || !item.html) return false;
      if(Date.now() - (item.createdAt || 0) > YF_PAGE_CACHE_TTL){ sessionStorage.removeItem(nativePageCacheKey()); return false; }
      res.innerHTML = item.html;
      clearRestoredEventBindings(res);
      if(item.breakdownMode || pageType === 'breakdowns') document.body.classList.add('yf-breakdown-mode');
      hydrateProducts(res);
      hydrateCollectionCards(res);
      initCollectionLinkSafety(res);
      initSerialSelectors(res);
      initCategoryWidgets();
      bindDiagramInteractions(res);
      requestAnimationFrame(function(){ requestAnimationFrame(function(){ window.scrollTo(item.scrollX || 0, item.scrollY || 0); }); });
      return true;
    }catch(e){ return false; }
  }

  const productJsonCache = {};
  const productsForPartCache = {};
  const supersessionResultCache = {};
  const supersessionChainResultCache = {};
  const inferBrandResultCache = {};
  function productContextKey(context){
    context = context || {};
    return [
      context.fastStatic ? 'fast' : 'live',
      (context.expectedBrands || []).map(rootBrand).filter(Boolean).sort().join(','),
      plain(context.expectedCategory || '')
    ].join('|');
  }
  const YF_BRAND_ALIASES = [
    ['SUBURBAN', ['SUBURBAN']],
    ['DOMETIC', ['DOMETIC','A&E','AE']],
    ['ATWOOD', ['ATWOOD']],
    ['NORCOLD', ['NORCOLD']],
    ['MAGICCHEF', ['MAGIC CHEF','MAGICCHEF']],
    ['WEDGEWOOD', ['WEDGEWOOD','WEDGEWOOD VISION','WEDGEWOOD VISION']],
    ['COLEMAN', ['COLEMAN','MACH','AIRXCEL']],
    ['CAREFREE', ['CAREFREE']],
    ['THETFORD', ['THETFORD']],
    ['LIPPERT', ['LIPPERT','LCI']],
    ['FURRION', ['FURRION']],
    ['DEXTER', ['DEXTER']],
    ['ARCON', ['ARCON']],
    ['CAMCO', ['CAMCO']],
    ['VALTERRA', ['VALTERRA']],
    ['SHURFLO', ['SHURFLO','SHUR FLO']],
    ['FLOJET', ['FLOJET']],
    ['JABSCO', ['JABSCO']],
    ['REMCO', ['REMCO']],
    ['WFCO', ['WFCO']],
    ['JENSEN', ['JENSEN']],
    ['DOMETIC_ATWOOD', ['DOMETIC ATWOOD','ATWOOD DOMETIC']]
  ];
  function plain(v){ return String(v || '').toUpperCase().replace(/\u00A0/g,' ').replace(/[^A-Z0-9]+/g,' ').replace(/\s+/g,' ').trim(); }
  function rootBrand(v){
    const h = plain(v);
    if(!h) return '';
    if(/\bSUBURBAN\b/.test(h)) return 'SUBURBAN';
    if(/\bNORCOLD\b/.test(h)) return 'NORCOLD';
    if(/\bMAGIC\s*CHEF\b|\bMAGICCHEF\b/.test(h)) return 'MAGICCHEF';
    if(/\bWEDGEWOOD\b/.test(h)) return 'WEDGEWOOD';
    if(/\bATWOOD\b/.test(h)) return 'ATWOOD';
    if(/\bDOMETIC\b|\bA\s*E\b/.test(h)) return 'DOMETIC';
    if(/\bCOLEMAN\b|\bMACH\b|\bAIRXCEL\b/.test(h)) return 'COLEMAN';
    if(/\bCAREFREE\b/.test(h)) return 'CAREFREE';
    if(/\bTHETFORD\b/.test(h)) return 'THETFORD';
    if(/\bLIPPERT\b|\bLCI\b/.test(h)) return 'LIPPERT';
    if(/\bFURRION\b/.test(h)) return 'FURRION';
    if(/\bDEXTER\b/.test(h)) return 'DEXTER';
    if(/\bARCON\b/.test(h)) return 'ARCON';
    if(/\bCAMCO\b/.test(h)) return 'CAMCO';
    if(/\bVALTERRA\b/.test(h)) return 'VALTERRA';
    if(/\bSHUR\s*FLO\b/.test(h)) return 'SHURFLO';
    if(/\bFLOJET\b/.test(h)) return 'FLOJET';
    if(/\bJABSCO\b/.test(h)) return 'JABSCO';
    if(/\bREMCO\b/.test(h)) return 'REMCO';
    if(/\bWFCO\b/.test(h)) return 'WFCO';
    return h.split(' ')[0] || '';
  }
  function strictRootBrand(v){
    const r = rootBrand(v);
    const known = new Set(['SUBURBAN','DOMETIC','ATWOOD','NORCOLD','MAGICCHEF','WEDGEWOOD','COLEMAN','CAREFREE','THETFORD','LIPPERT','FURRION','DEXTER','ARCON','CAMCO','VALTERRA','SHURFLO','FLOJET','JABSCO','REMCO','WFCO']);
    return known.has(r) ? r : '';
  }
  function relatedBrandSet(brands, category){
    const set = new Set((brands || []).map(rootBrand).filter(Boolean));
    const cat = plain(category);
    // Atwood water heaters are often branded/sold as Dometic/Atwood. Allow that specific family,
    // but do not allow it for unrelated brands like Suburban.
    if((set.has('ATWOOD') || set.has('DOMETIC')) && /WATER HEATER|HOT WATER/.test(cat)){ set.add('ATWOOD'); set.add('DOMETIC'); }
    return set;
  }
  function brandLabelFromRoot(v){
    const r = rootBrand(v);
    const labels = {SUBURBAN:'Suburban',DOMETIC:'Dometic',ATWOOD:'Atwood',NORCOLD:'Norcold',MAGICCHEF:'Magic Chef',WEDGEWOOD:'Wedgewood',COLEMAN:'Coleman/Airxcel',CAREFREE:'Carefree',THETFORD:'Thetford',LIPPERT:'Lippert',FURRION:'Furrion',DEXTER:'Dexter',ARCON:'Arcon',CAMCO:'Camco',VALTERRA:'Valterra',SHURFLO:'SHURflo',FLOJET:'Flojet',JABSCO:'Jabsco',REMCO:'Remco',WFCO:'WFCO'};
    return labels[r] || String(v || '').replace(/_/g,' ').replace(/\w/g, c => c.toUpperCase());
  }
  function partBrandLabel(part, ctx){
    const brands = (ctx && ctx.expectedBrands) || [];
    if(brands.length) return brandLabelFromRoot(brands[0]);
    if(part && part.used && part.used.length) return '';
    return '';
  }
  function detectedProductBrands(p){
    const hay = plain([p && p.vendor, p && p.title, p && p.productType, p && p.type].filter(Boolean).join(' '));
    const found = new Set();
    YF_BRAND_ALIASES.forEach(([canon, aliases]) => aliases.forEach(a => { const aa = plain(a); if(aa && hay.includes(aa)) found.add(canon === 'DOMETIC_ATWOOD' ? 'DOMETIC' : canon); }));
    return found;
  }
  function productPassesCategoryContext(product, candidate){
    const exp = plain((candidate && candidate._expectedCategory) || '');
    if(!exp) return false;
    const hay = plain([product && product.productType, product && product.type, product && product.title, product && product.vendor].filter(Boolean).join(' '));
    if(!hay) return false;
    if(/FURNACE/.test(exp)) return /FURNACE|HEATER|SUBURBAN/.test(hay) && !/WATER HEATER|HOT WATER/.test(hay);
    if(/WATER HEATER|HOT WATER/.test(exp)) return /WATER HEATER|HOT WATER|ATWOOD|SUBURBAN|DOMETIC/.test(hay);
    if(/REFRIGERATOR|FRIDGE/.test(exp)) return /REFRIGERATOR|FRIDGE|NORCOLD|DOMETIC/.test(hay);
    if(/AIR CONDITIONER|AIRCONDITIONER/.test(exp)) return /AIR CONDITIONER|A\/C|AC |COLEMAN|MACH|DOMETIC/.test(hay);
    // RV range/oven/stove parts are often product-typed as burners, knobs, grates, valves, pilots, racks, hinges, doors, etc.
    // Do not require the literal word "range" or we will hide correct Magic Chef/Wedgewood range products.
    if(/RANGE|OVEN|STOVE|COOKTOP|COOK TOP/.test(exp)) return /RANGE|OVEN|STOVE|COOKTOP|COOK TOP|BURNER|GRATE|KNOB|PILOT|REGULATOR|VALVE|RACK|HINGE|DOOR|MANIFOLD|GROMMET|MAGIC CHEF|MAGICCHEF|WEDGEWOOD|ATWOOD|SUBURBAN/.test(hay);
    if(/AWNING/.test(exp)) return /AWNING|CAREFREE|DOMETIC|A\s*E/.test(hay);
    if(/PUMPS?|WATER PUMP|FRESH WATER|WASTE WATER/.test(exp)) return /PUMPS?|WATER PUMP|FRESH WATER|WASTE WATER|FLOJET|JABSCO|SHUR\s*FLO|SHURFLO|REMCO|THETFORD|WFCO/.test(hay) && !/VACUUM|CENTRAL VAC/.test(hay);
    const first = exp.split(' ')[0] || '';
    return !!first && (hay.includes(first) || hay.includes(first.replace(/S$/, '')) || hay.includes(first + 'S'));
  }
  function productMetafieldMatchesCandidate(product, candidate){
    const target = norm((candidate && (candidate._targetPart || candidate._matchedPart || candidate.partNumber || candidate.p)) || '');
    if(!target) return true;
    const mf = norm((candidate && (candidate._metafieldPartNumber || candidate.metafieldPartNumber || candidate.partNumber)) || '');
    // Visible smart-panel products must be grounded in the Shopify product metafield.
    // SKU/title-only matches are too risky because part numbers repeat across brands/categories.
    return !!mf && mf === target;
  }
  function productPassesBrandContext(product, candidate){
    const expected = relatedBrandSet(candidate && candidate._expectedBrands, candidate && candidate._expectedCategory);
    if(!expected.size) return true;
    const productBrands = detectedProductBrands(product);
    for(const b of productBrands){ if(expected.has(b)) return true; }
    // If the product is not clearly branded, require category/family agreement instead of accepting it blindly.
    if(!productBrands.size) return productPassesCategoryContext(product, candidate);
    return false;
  }
  async function inferBrandsForPartNumber(partNumber, existingPart){
    const cacheKey = norm(partNumber);
    if(cacheKey && !existingPart && inferBrandResultCache[cacheKey]) return inferBrandResultCache[cacheKey];
    const promise = (async () => {
    const part = existingPart || await db.part(partNumber);
    const brands = new Set();
    const categoryHints = new Set();
    // Do not treat the first word of a plain description as a brand.
    // Example: "BACK, FLUE COLLECTOR" used to become brand "Back".
    // Only use known brand words from the description; otherwise infer brand from connected diagrams/models.
    const descBrand = strictRootBrand(part && part.d);
    if(descBrand) brands.add(descBrand);
    for(const u of ((part && part.used) || []).slice(0, 18)){
      const did = u && u[2];
      if(!did) continue;
      const d = await db.diagram(did);
      const rb = rootBrand(d && d.b);
      if(rb) brands.add(rb);
      if(d && d.c) categoryHints.add(d.c);
    }
    return {expectedBrands:[...brands], expectedCategory:[...categoryHints][0] || ''};
    })();
    if(cacheKey && !existingPart) inferBrandResultCache[cacheKey] = promise;
    return promise;
  }
  async function shopifyProduct(handle){
    if(!handle) return null;
    if(productJsonCache[handle] !== undefined) return productJsonCache[handle];
    productJsonCache[handle] = (async () => {
      try{
        const r = await fetch('/products/' + handle + '.js', {credentials:'same-origin'});
        if(!r.ok) return null;
        return await r.json();
      }catch(e){ return null; }
    })();
    return productJsonCache[handle];
  }
  function bestVariant(j){ if(!j || !Array.isArray(j.variants) || !j.variants.length) return null; return j.variants.find(v => v.available) || j.variants[0]; }
  function variantForSku(j, sku){
    if(!j || !Array.isArray(j.variants) || !j.variants.length) return null;
    const k = skuKey(sku);
    return j.variants.find(v => skuKey(v && v.sku) === k) || bestVariant(j);
  }
  function variantIdFromProduct(p, v){
    if(v && v.id) return String(v.id);
    const raw = String((p && p.variantId) || '');
    return raw ? raw.split('/').pop() : '';
  }
  function productImage(j){ return (j && (j.featured_image || (j.images && j.images[0]))) || ''; }
  async function liveProductFromCandidate(p){
    if(!p || !p.handle) return null;
    if(!productMetafieldMatchesCandidate(null, p)) return null;
    const j = await shopifyProduct(p.handle);
    if(!j) return null;
    const v = bestVariant(j);
    if(!v || !v.available || j.available === false) return null;
    const live = {
      handle: j.handle || p.handle,
      title: j.title || p.title || p.handle,
      url: '/products/' + (j.handle || p.handle),
      imageUrl: productImage(j) || p.imageUrl || '',
      vendor: j.vendor || p.vendor || '',
      productType: j.type || p.productType || '',
      price: v.price,
      compareAtPrice: v.compare_at_price || j.compare_at_price || p.compareAtPrice || null,
      sku: v.sku || p.sku || '',
      partNumber: p.partNumber || p.p || p._matchedPart || '',
      metafieldPartNumber: p.metafieldPartNumber || p._metafieldPartNumber || p.partNumber || '',
      available: true
    };
    if(!productPassesBrandContext(live, p)) return null;
    return live;
  }
  function candidateLooksAvailable(p){
    if(!p) return false;
    if(p.available === false) return false;
    if(p.inventory != null && Number(p.inventory) <= 0) return false;
    return true;
  }
  function staticProductFromCandidate(p){
    if(!p || !p.handle) return null;
    if(!productMetafieldMatchesCandidate(null, p)) return null;
    if(!candidateLooksAvailable(p)) return null;
    const live = {
      handle: p.handle,
      title: p.title || p.handle,
      url: p.url || ('/products/' + p.handle),
      imageUrl: p.imageUrl || p.image || '',
      vendor: p.vendor || '',
      productType: p.productType || p.type || '',
      price: p.price || '',
      compareAtPrice: p.compareAtPrice || null,
      sku: p.sku || '',
      partNumber: p.partNumber || p.p || p._matchedPart || '',
      metafieldPartNumber: p.metafieldPartNumber || p._metafieldPartNumber || p.partNumber || '',
      available: true,
      _fastStatic: true
    };
    if(!productPassesBrandContext(live, p)) return null;
    return live;
  }
  async function enrichProductsFastStatic(candidates, limit){
    const unique = [], seen = new Set();
    for(const p of (candidates || [])){
      const h = p && p.handle;
      if(!h || seen.has(h)) continue;
      seen.add(h);
      const live = staticProductFromCandidate(p);
      if(live) unique.push(Object.assign({}, live, {_matchedPart:p._matchedPart, _label:p._label, _klass:p._klass}));
      if(limit && unique.length >= limit) break;
    }
    return unique.slice(0, limit || unique.length);
  }

  async function enrichProducts(candidates, limit){
    // V33 speed fix: validate Shopify products in parallel instead of one-by-one.
    // The cards still come from yf_extracted_data.part_number matches and still require live Shopify availability,
    // but the user no longer waits for every handle sequentially.
    const unique = [], seen = new Set();
    for(const p of (candidates || [])){
      const h = p && p.handle;
      if(!h || seen.has(h)) continue;
      seen.add(h);
      unique.push(p);
    }
    const max = limit || unique.length;
    const out = [];
    let cursor = 0;
    async function worker(){
      while(cursor < unique.length && out.length < max){
        const p = unique[cursor++];
        try{
          const live = await liveProductFromCandidate(p);
          if(live && out.length < max){
            out.push(Object.assign({}, live, {_matchedPart:p._matchedPart, _label:p._label, _klass:p._klass}));
          }
        }catch(e){}
      }
    }
    await Promise.all(Array.from({length: Math.min(12, unique.length || 1)}, worker));
    return out.slice(0, max);
  }

  async function filterLiveOnlineInStockProducts(products, limit){
    const unique = [], seen = new Set();
    for(const p of (products || [])){
      const handle = p && (p.handle || handleFromProductUrl(p.url));
      if(!handle || seen.has(handle)) continue;
      seen.add(handle);
      unique.push(Object.assign({}, p, {handle}));
    }
    const max = limit || unique.length;
    const out = [];
    let cursor = 0;
    async function worker(){
      while(cursor < unique.length && out.length < max){
        const p = unique[cursor++];
        try{
          if(p.inventory != null && p.inventory !== '' && isFinite(Number(p.inventory)) && Number(p.inventory) <= 0) continue;
          const j = await shopifyProduct(p.handle);
          if(!j || j.available === false) continue;
          const v = bestVariant(j);
          if(!v || !v.available) continue;
          if(v.inventory_quantity != null && isFinite(Number(v.inventory_quantity)) && Number(v.inventory_quantity) <= 0) continue;
          const variantId = variantIdFromProduct(p, v);
          out.push(Object.assign({}, p, {
            handle: j.handle || p.handle,
            title: j.title || p.title || p.handle,
            url: '/products/' + (j.handle || p.handle) + (variantId ? '?variant=' + enc(variantId) : ''),
            imageUrl: productImage(j) || p.imageUrl || p.image || '',
            vendor: j.vendor || p.vendor || '',
            productType: j.type || p.productType || p.type || '',
            price: v.price != null ? v.price : p.price,
            compareAtPrice: v.compare_at_price || j.compare_at_price || p.compareAtPrice || null,
            sku: v.sku || p.sku || '',
            inventory: v.inventory_quantity != null ? v.inventory_quantity : p.inventory,
            available: true
          }));
        }catch(e){}
      }
    }
    await Promise.all(Array.from({length: Math.min(10, unique.length || 1)}, worker));
    return out.slice(0, max);
  }
  function handleFromProductUrl(url){
    try{
      const u = new URL(url || '', location.origin);
      const m = u.pathname.match(/\/products\/([^\/?#]+)/);
      return m ? decodeURIComponent(m[1]) : '';
    }catch(e){
      const m = String(url || '').match(/\/products\/([^\/?#]+)/);
      return m ? decodeURIComponent(m[1]) : '';
    }
  }
  const searchProductCache = {};
  async function shopifySearchProductsForPart(pn, context){
    const k = norm(pn);
    if(!k) return [];
    if(searchProductCache[k]) return searchProductCache[k];
    searchProductCache[k] = (async () => {
      const out = [];
      try{
        // This alternate Shopify search template returns live Shopify products plus the yf_extracted_data.part_number metafield.
        // It lets the native theme find products that Shopify already knows about even if the static export missed them.
        const r = await fetch('/search?type=product&view=yfjson&q=' + enc(pn), {credentials:'same-origin'});
        if(r.ok){
          const j = await r.json();
          (j.products || []).forEach(p => {
            const mf = norm(p.partNumber || p.metafieldPartNumber || '');
            const sku = norm(p.sku || '');
            if(mf === k || (!mf && sku === k)){
              const handle = p.handle || handleFromProductUrl(p.url);
              if(handle){ out.push(Object.assign({}, p, {handle, _matchedPart: pn, _targetPart: pn, _metafieldPartNumber: p.partNumber || p.metafieldPartNumber || '', partNumber: p.partNumber || pn, _expectedBrands:(context&&context.expectedBrands)||[], _expectedCategory:(context&&context.expectedCategory)||'', matchSource: 'live-shopify-search'})); }
            }
          });
        }
      }catch(e){}
      // Do not use predictive-search for product cards here. It does not expose yf_extracted_data.part_number,
      // so it can return unrelated products that happen to share the same numeric code.
      // Dedupe by handle before returning candidates.
      const seen = new Set();
      return out.filter(p => { const h = p.handle || handleFromProductUrl(p.url); if(!h || seen.has(h)) return false; seen.add(h); return true; });
    })();
    return searchProductCache[k];
  }
  async function productsForPart(pn, context){
    context = context || {};
    const partKey = norm(pn);
    const cacheKey = partKey + '|' + productContextKey(context);
    if(productsForPartCache[cacheKey]) return productsForPartCache[cacheKey];
    productsForPartCache[cacheKey] = (async () => {
      const pp = await db.productPart(pn);
      const staticCandidates = [...(pp && pp.products || [])].map(p => Object.assign({}, p, {_matchedPart: pn, _targetPart: pn, _metafieldPartNumber: p.partNumber || p.metafieldPartNumber || pn, partNumber: p.partNumber || pn, _expectedBrands:context.expectedBrands || [], _expectedCategory:context.expectedCategory || ''}));

      // V61 speed path: model/breakdown pages often check 50-200 part numbers.
      // The generated product-part index already contains active Shopify availability/inventory,
      // so bulk pages can render matching product cards immediately and hydrate images/prices in the background.
      if(context.fastStatic){
        return enrichProductsFastStatic(staticCandidates, 80);
      }

      const liveSearchCandidates = await shopifySearchProductsForPart(pn, context);
      const all = [];
      const seen = new Set();
      [...staticCandidates, ...liveSearchCandidates].forEach(p => {
        const h = p && (p.handle || handleFromProductUrl(p.url));
        if(!h || seen.has(h)) return;
        seen.add(h);
        all.push(Object.assign({}, p, {handle:h, _matchedPart: pn, _targetPart: pn, _metafieldPartNumber: p._metafieldPartNumber || p.metafieldPartNumber || p.partNumber || '', partNumber: p.partNumber || pn, _expectedBrands:context.expectedBrands || p._expectedBrands || [], _expectedCategory:context.expectedCategory || p._expectedCategory || ''}));
      });
      return enrichProducts(all, 80);
    })();
    return productsForPartCache[cacheKey];
  }
  async function productForPart(pn, context){ const ps = await productsForPart(pn, context || {}); return ps[0] || null; }

  let allIndexedProductsPromise = null;
  async function allIndexedProducts(){
    if(allIndexedProductsPromise) return allIndexedProductsPromise;
    allIndexedProductsPromise = (async () => {
      await db.init();
      const chunks = (db.manifest && db.manifest.chunks && db.manifest.chunks['product-part']) || {};
      const out = [];
      const seen = new Set();
      await Promise.all(Object.keys(chunks).map(async b => {
        const ch = await db.load('product-part', b);
        Object.keys(ch || {}).forEach(k => {
          const rec = ch[k];
          (rec && rec.products || []).forEach(p => {
            const h = p && p.handle;
            if(!h || seen.has(h)) return;
            seen.add(h);
            out.push(p);
          });
        });
      }));
      return out;
    })();
    return allIndexedProductsPromise;
  }
  async function relatedProductsForSkuProduct(product, part, limit){
    const all = await allIndexedProducts();
    const handle = product && product.handle;
    const exactSku = skuKey(product && product.sku);
    const productType = plain(product && product.productType);
    const vendor = rootBrand(product && product.vendor);
    const usedPartNumbers = new Set([norm(product && product.partNumber), norm(part && part.p)].filter(Boolean));
    const scored = [];
    all.forEach(p => {
      if(!p || !p.handle || p.handle === handle) return;
      if(exactSku && skuKey(p.sku) === exactSku) return;
      if(p.available === false) return;
      const pt = plain(p.productType);
      const pv = rootBrand(p.vendor);
      let score = 0;
      if(productType && pt === productType) score += 90;
      else if(productType && pt && (pt.includes(productType) || productType.includes(pt))) score += 45;
      if(vendor && pv === vendor) score += 25;
      if(usedPartNumbers.has(norm(p.partNumber))) score -= 200;
      if(score > 0) scored.push(Object.assign({}, p, {_score:score}));
    });
    scored.sort((a,b) => (b._score-a._score) || Number(b.inventory||0)-Number(a.inventory||0) || String(a.title||'').localeCompare(String(b.title||'')));
    return scored.slice(0, limit || 6);
  }
  async function enrichSkuProduct(p){
    if(!p || !p.handle) return p;
    const j = await shopifyProduct(p.handle);
    if(!j) return p;
    const v = variantForSku(j, p.sku);
    const variantId = variantIdFromProduct(p, v);
    return Object.assign({}, p, {
      title: j.title || p.title,
      vendor: j.vendor || p.vendor,
      productType: j.type || p.productType,
      imageUrl: productImage(j) || p.imageUrl || '',
      price: (v && v.price != null) ? v.price : p.price,
      compareAtPrice: (v && v.compare_at_price != null) ? v.compare_at_price : p.compareAtPrice,
      sku: (v && v.sku) || p.sku,
      available: v ? !!v.available : p.available,
      variantId: variantId || p.variantId,
      url: '/products/' + (j.handle || p.handle) + (variantId ? '?variant=' + enc(variantId) : '')
    });
  }

  async function supersessionFor(pn){
    const k = norm(pn);
    if(supersessionResultCache[k]) return supersessionResultCache[k];
    supersessionResultCache[k] = (async () => {
      const all = await db.supersessions();
      const rec = all[k] || {partNumber: pn, supersededBy: [], supersededParts: []};
      const part = await db.part(pn);
      if(part){
        for(const x of part.replacedBy || []){ const nx = norm(x); if(nx && !rec.supersededBy.includes(nx)) rec.supersededBy.push(nx); }
        for(const x of part.replaces || []){ const nx = norm(x); if(nx && !rec.supersededParts.includes(nx)) rec.supersededParts.push(nx); }
        const m = String(part.d || '').match(/\bUSE\s*:?\s*([A-Z0-9][A-Z0-9\-\./]{1,30})/i);
        if(m){ const nx = norm(m[1]); if(nx && !rec.supersededBy.includes(nx)) rec.supersededBy.push(nx); }
      }
      return rec;
    })();
    return supersessionResultCache[k];
  }
  async function supersessionChain(pn){
    const searched = norm(pn);
    if(supersessionChainResultCache[searched]) return supersessionChainResultCache[searched];
    supersessionChainResultCache[searched] = (async () => {
      const forward = [], seen = new Set([searched]);
      let cur = searched;
      for(let i=0;i<6;i++){
        const s = await supersessionFor(cur); const n = (s.supersededBy || [])[0];
        if(!n || seen.has(n)) break;
        forward.push(n); seen.add(n); cur = n;
      }
      const reverse = [];
      for(const k of [searched, ...forward]){
        const s = await supersessionFor(k);
        for(const old of s.supersededParts || []){ const no = norm(old); if(no && !seen.has(no)){ reverse.push(no); seen.add(no); } }
      }
      return {searched, current: forward.length ? forward[forward.length-1] : searched, forward, reverse};
    })();
    return supersessionChainResultCache[searched];
  }
  async function productsForChain(pn, context){
    context = context || await inferBrandsForPartNumber(pn);
    const ch = await supersessionChain(pn);
    const order = [];
    if(ch.forward.length) order.push(...ch.forward.slice().reverse().map(p => [p, 'Current replacement', 'blue']));
    order.push([ch.searched, ch.forward.length ? 'Legacy part' : 'Exact match', ch.forward.length ? 'amber' : 'green']);
    order.push(...ch.reverse.map(p => [p, 'Older number', 'amber']));
    const out = [], seen = new Set();
    for(const [part, label, klass] of order){
      const partCtx = part === norm(pn) ? context : (context && context.expectedBrands && context.expectedBrands.length ? context : await inferBrandsForPartNumber(part));
      const ps = await productsForPart(part, partCtx);
      for(const p of ps){ const key = p.handle || p.url || p.title; if(key && !seen.has(key)){ seen.add(key); out.push({product:p, matchedPart:part, label, klass}); } }
    }
    return {chain: ch, items: out};
  }
  async function productsForPartsDirect(parts, limit, context){
    // Fast path for model/diagram pages: match each diagram part number directly to Shopify products.
    // V78: when used for replacement-part panels, re-check every candidate against /products/{handle}.js.
    // That guarantees the card is still active, published to the Online Store, and actually in stock.
    const max = limit || 96;
    const input = [...new Set((parts || []).map(x => String(x || '').trim()).filter(Boolean).map(norm))].slice(0, 160);
    const requireOnlineStore = !!(context && context.requireOnlineStore);
    const poolMax = requireOnlineStore ? Math.max(max * 3, max + 24) : max;
    const out = [], seen = new Set();
    const bulkContext = Object.assign({}, context || {}, {fastStatic:true});
    let cursor = 0;
    async function worker(){
      while(cursor < input.length && out.length < poolMax){
        const pn = input[cursor++];
        try{
          const ps = await productsForPart(pn, bulkContext);
          for(const p of ps){
            const key = p && (p.handle || p.url || p.title);
            if(key && !seen.has(key)){
              seen.add(key);
              out.push(Object.assign({}, p, {_matchedPart:pn, _label:'Matching part', _klass:'green'}));
              if(out.length >= poolMax) break;
            }
          }
        }catch(e){ console.warn('Direct product match failed for part', pn, e); }
      }
    }
    await Promise.all(Array.from({length: Math.min(14, input.length || 1)}, worker));
    if(requireOnlineStore) return filterLiveOnlineInStockProducts(out, max);
    return out.slice(0, max);
  }


  const modelReversePartCache = {};
  async function partNumbersThatFitModel(model){
    if(!model) return [];
    const modelKey = norm(model.m);
    if(!modelKey) return [];
    if(modelReversePartCache[modelKey]) return modelReversePartCache[modelKey];
    modelReversePartCache[modelKey] = (async () => {
      const out = new Set();
      const diagramIds = new Set();
      try{
        const summaries = (model._allDiagrams && model._allDiagrams.length) ? model._allDiagrams : await allDiagramSummariesForModel(model);
        (summaries || []).forEach(d => { if(d && d.id) diagramIds.add(String(d.id)); });
        const full = await fullDiagramsFromSummaries(summaries || []);
        (full || []).forEach(d => { if(d && d.id) diagramIds.add(String(d.id)); });
      }catch(e){}
      try{
        const all = await db.allParts();
        Object.keys(all || {}).forEach(k => {
          const rec = all[k];
          if(!rec || !Array.isArray(rec.used)) return;
          const fits = rec.used.some(u => {
            const usedModel = norm((Array.isArray(u) ? u[0] : (u && (u.model || u.m))) || '');
            const usedDiagram = String((Array.isArray(u) ? u[2] : (u && (u.diagram_id || u.diagramId || u.d))) || '');
            return usedModel === modelKey || (usedDiagram && diagramIds.has(usedDiagram));
          });
          if(fits){
            const pn = rec.p || rec.n || k;
            const nk = norm(pn);
            if(nk) out.add(pn);
          }
        });
      }catch(e){ console.warn('Could not scan reverse part/model compatibility', e); }
      return Array.from(out);
    })();
    return modelReversePartCache[modelKey];
  }

  async function productsForParts(parts, limit, context){
    const max = limit || 96;
    const input = [...new Set((parts || []).map(x => String(x || '').trim()).filter(Boolean).map(norm))].slice(0, 220);
    const out = [], seen = new Set();
    const bulkContext = (context && context.forceLiveSearch) ? Object.assign({}, context || {}, {fastStatic:false}) : Object.assign({}, context || {}, {fastStatic:true});
    let cursor = 0;
    async function worker(){
      while(cursor < input.length && out.length < max){
        const pn = input[cursor++];
        try{
          const res = await productsForChain(pn, bulkContext);
          for(const item of res.items){
            const p = item.product; const key = p && (p.handle || p.url || p.title);
            if(key && !seen.has(key)){
              seen.add(key);
              out.push(Object.assign({}, p, {_matchedPart:item.matchedPart, _label:item.label, _klass:item.klass}));
              if(out.length >= max) break;
            }
          }
        }catch(e){ console.warn('Product match failed for part', pn, e); }
      }
    }
    await Promise.all(Array.from({length: Math.min(8, input.length || 1)}, worker));
    return out.slice(0, max);
  }
  async function productsForModel(model, limit){
    // V55: Model-result products must mirror the products available from EVERY
    // connected breakdown diagram. Build one full part-number set from:
    // 1) model.parts, 2) every associated full diagram.parts row, and
    // 3) legacy/replaced rows that enrichDiagramParts can recover from part_knowledge.used.
    // Then run the same exact/direct lookup used by breakdown pages first, because that is
    // the source the user can visually verify from each breakdown. Finally add supersession
    // chain matches as extras without replacing the exact breakdown matches.
    if(!model) return [];
    const parts = new Set();
    (model.parts || []).forEach(p => { const k = norm(p); if(k) parts.add(k); });
    try{
      const summaries = (model._allDiagrams && model._allDiagrams.length) ? model._allDiagrams : await allDiagramSummariesForModel(model);
      const full = await fullDiagramsFromSummaries(summaries || []);
      for(const d of (full || [])){
        const enriched = await enrichDiagramParts(d, model);
        (enriched || []).forEach(row => { const k = norm(row && row[1]); if(k) parts.add(k); });
      }
      partNumbersFromDiagrams(full).forEach(p => { const k = norm(p); if(k) parts.add(k); });
    }catch(e){ console.warn('Could not load all model breakdown parts for product matching', e); }
    let reverseParts = [];
    try{
      reverseParts = await partNumbersThatFitModel(model);
      (reverseParts || []).forEach(p => { const k = norm(p); if(k) parts.add(k); });
    }catch(e){ console.warn('Could not load reverse model part matches', e); }
    const ctx = {expectedBrands:[model.b], expectedCategory:model.c, requireOnlineStore:true};
    const max = limit || 120;
    const direct = await productsForPartsDirect([...parts], max, ctx);
    const chain = await productsForParts([...parts], max, ctx);
    const reverseLive = (reverseParts && reverseParts.length) ? await productsForParts(reverseParts, max, Object.assign({}, ctx, {forceLiveSearch:true})) : [];
    const out = [], seen = new Set();
    [...direct, ...chain, ...reverseLive].forEach(p => {
      const key = p && (p.handle || p.url || p.title);
      if(key && !seen.has(key) && out.length < Math.max(max * 2, max + 24)){ seen.add(key); out.push(p); }
    });
    return filterLiveOnlineInStockProducts(out, max);
  }
  async function productsForCompleteUnit(model, originalQuery, limit){
    const candidates = [];
    const ctx = {expectedBrands:[model && model.b].filter(Boolean), expectedCategory:model && model.c};
    function add(v){ v = String(v || '').trim(); if(!v) return; if(!candidates.map(norm).includes(norm(v))) candidates.push(v); }
    add(originalQuery);
    add(model && model.m);
    add(model && model.n);
    if(model && model.m) add(String(model.m).replace(/\s+Series$/i, '').trim());
    if(originalQuery) add(String(originalQuery).replace(/\s+Series$/i, '').trim());
    const out = [], seen = new Set();
    for(const c of candidates){
      const ps = await productsForPart(c, ctx);
      for(const p of ps){
        const key = p.handle || p.url || p.title;
        if(key && !seen.has(key)){ seen.add(key); out.push(Object.assign({}, p, {_matchedPart:c, _label:'Complete unit', _klass:'green'})); if(limit && out.length >= limit) return out; }
      }
    }
    return out;
  }
  async function allDiagramSummariesForModel(model, serial){
    const keys = [];
    if(model){ keys.push(model._lookupModelKey, model.n, model.m); }
    const unique = [...new Set(keys.map(norm).filter(Boolean))];
    let all = [];
    for(const k of unique){
      try{
        const arr = await db.modelDiagrams(k);
        if(arr && arr.length){ all = arr; break; }
      }catch(e){}
    }
    if(!all.length) all = (model && model.diagrams) || [];
    const serialFilter = serial || (model && model._serial) || '';
    if(serialFilter) all = all.filter(d => serialMatches(d && d.s, serialFilter));
    const seen = new Set(), out = [];
    all.forEach(d => { const id = d && d.id; if(id && !seen.has(id)){ seen.add(id); out.push(d); } });
    return displayDiagrams(out);
  }

  async function fullDiagramsFromSummaries(summaries){
    return mapLimit((summaries || []), 10, async d => {
      if(d && Array.isArray(d.parts) && d.parts.length) return d;
      const full = d && d.id ? await db.diagram(d.id) : null;
      return full || d;
    });
  }

  const collectionImageCache = {};
  function firstProductImageFromCollectionProduct(p){
    if(!p) return '';
    if(typeof p.image === 'string') return p.image;
    if(p.image && p.image.src) return p.image.src;
    if(Array.isArray(p.images)){
      for(const img of p.images){
        if(typeof img === 'string') return img;
        if(img && img.src) return img.src;
      }
    }
    return '';
  }
  async function collectionImage(handle){
    handle = canonicalCollectionHandle(handle);
    if(!handle) return '';
    if(collectionImageCache[handle] !== undefined) return collectionImageCache[handle];
    collectionImageCache[handle] = (async () => {
      try{
        // V36/V61: if a collection has no dedicated collection image, use the first available product
        // image from the collection instead of leaving the recommended card blank. Cache in-flight requests too.
        const r = await fetch('/collections/' + handle + '/products.json?limit=20', {credentials:'same-origin'});
        if(!r.ok) return '';
        const j = await r.json();
        for(const p of (j.products || [])){
          const img = firstProductImageFromCollectionProduct(p);
          if(img) return img;
        }
        return '';
      }catch(e){ return ''; }
    })();
    return collectionImageCache[handle];
  }
  function cleanCategoryName(v){
    let s = String(v || '').replace(/[_-]+/g,' ').trim();
    const map = {'water heater':'Water Heaters','water heaters':'Water Heaters','hot water heater':'Water Heaters','furnace':'Furnaces','furnaces':'Furnaces','fridge':'Refrigerators','fridges':'Refrigerators','refrigerator':'Refrigerators','refrigerators':'Refrigerators','air conditioner':'Air Conditioners','air conditioners':'Air Conditioners','awning':'Awnings','awnings':'Awnings'};
    const k = s.toLowerCase(); if(map[k]) return map[k];
    return s.replace(/\b\w/g, m => m.toUpperCase()).replace(/\bRv\b/g,'RV');
  }

  const YF_COLLECTION_ALIASES = {
    // V35: dropdown/category links must never build guessed handles that 404.
    // These aliases force common display/title guesses back to the real Shopify collection handles.
    'water-pumps-accessories':'pompes-et-accessoires',
    'pumps-accessories':'pompes-et-accessoires',
    'water-pump':'pompes-et-accessoires',
    'water-pumps':'pompes-et-accessoires',
    'used-rv-water-pumps-parts':'used-water-pumps-parts',
    'used-water-pump-parts':'used-water-pumps-parts',
    'rv-water-pumps-parts':'used-water-pumps-parts',
    'new-rv-ladders-bunk-ladders':'new-rv-ladders-bunk-ladders',
    'rv-ladders-bunk-ladders':'new-rv-ladders-bunk-ladders',
    'new-rv-refrigerator-replacement-parts':'new-used-rv-refrigerators-replacement-parts',
    'new-rv-refrigerators-replacement-parts':'new-used-rv-refrigerators-replacement-parts',
    'new-rv-water-heater-replacement-parts':'new-used-rv-hot-water-heaters',
    'new-rv-hot-water-heaters':'new-used-rv-hot-water-heaters',
    'new-rv-furnaces-replacement-parts':'new-used-rv-furnaces-replacement-parts',
    'new-rv-furnace-replacement-parts':'new-used-rv-furnaces-replacement-parts',
    'new-rv-air-conditioners-replacement-parts':'new-used-rv-air-conditioners-replacement-parts',
    'rv-air-conditioners-replacement-parts':'new-used-rv-air-conditioners-replacement-parts',
    'rv-rims-and-tires':'used-rv-rims-tires',
    'rims-and-tires':'used-rv-rims-tires',
    'rv-rims-tires':'used-rv-rims-tires',
    'rv-tires':'used-rv-rims-tires',
    'tires':'used-rv-rims-tires',
    'tire':'used-rv-rims-tires',
    'rv-vacuum-cleaners-and-accessories':'rv-vacuum-cleaners-accessories',
    'vacuum-cleaners-accessories':'rv-vacuum-cleaners-accessories',
    'central-vacuum-systems':'rv-vacuum-cleaners-accessories',
    'covers':'rv-covers',
    'rv-wheel-covers':'rv-covers'
  };
  const YF_CATEGORY_TO_COLLECTION = {
    'WATERHEATER':'new-used-rv-hot-water-heaters',
    'HOTWATERHEATER':'new-used-rv-hot-water-heaters',
    'WATERHEATERS':'new-used-rv-hot-water-heaters',
    'WATER_HEATER':'new-used-rv-hot-water-heaters',
    'REFRIGERATOR':'new-used-rv-refrigerators-replacement-parts',
    'REFRIGERATORS':'new-used-rv-refrigerators-replacement-parts',
    'FRIDGE':'new-used-rv-refrigerators-replacement-parts',
    'FURNACE':'new-used-rv-furnaces-replacement-parts',
    'FURNACES':'new-used-rv-furnaces-replacement-parts',
    'AIRCONDITIONER':'new-used-rv-air-conditioners-replacement-parts',
    'AIRCONDITIONERS':'new-used-rv-air-conditioners-replacement-parts',
    'AC':'new-used-rv-air-conditioners-replacement-parts',
    'AWNING':'new-rv-awnings-replacement-parts-accessories',
    'AWNINGS':'new-rv-awnings-replacement-parts-accessories',
    'WATERPUMP':'pompes-et-accessoires',
    'WATERPUMPS':'pompes-et-accessoires',
    'PUMP':'pompes-et-accessoires',
    'PUMPS':'pompes-et-accessoires',
    'LADDER':'new-rv-ladders-bunk-ladders',
    'LADDERS':'new-rv-ladders-bunk-ladders'
  };

  // V28: Shopify-native curated category engine.
  // This mirrors the old server-side order: preprocess query -> detect condition -> curated collection scoring -> selector category.
  // The theme cannot run Gemini, but it can run the same deterministic curated/category layer natively.
  const YF_COMPOUND_FIXES = [
    ['waterheater','water heater'], ['hotwaterheater','hot water heater'], ['waterpumps','water pumps'], ['waterpump','water pump'], ['water pups','water pumps'], ['waterpups','water pumps'], ['water pup','water pump'],
    ['airconditioner','air conditioner'], ['gasvalve','gas valve'],
    ['coolingunit','cooling unit'], ['slideout','slide out'], ['ignitionboard','ignition board'], ['thermocouple','thermocouple'],
    ['thermalcouple','thermocouple'], ['furnase','furnace'], ['furnece','furnace'], ['refridgerator','refrigerator'], ['frige','fridge'], ['thermstat','thermostat'], ['laders','ladders'], ['lader','ladder']
  ];
  const YF_STOP_WORDS = new Set(['a','an','the','for','in','of','rv','replacement','parts','part','accessories','accessory','looking','need','want','find','show','me','my','to','with','and','or','on','please']);
  function singularToken(t){
    t = String(t || '').trim();
    if(t.length <= 3) return t;
    if(/ies$/.test(t)) return t.slice(0,-3)+'y';
    if(/sses$/.test(t)) return t.slice(0,-2);
    if(/ches$|shes$|xes$|zes$/.test(t)) return t.slice(0,-2);
    if(/s$/.test(t) && !/ss$/.test(t)) return t.slice(0,-1);
    return t;
  }
  function cleanQueryForCategory(q){
    let out = String(q || '').toLowerCase();
    YF_COMPOUND_FIXES.forEach(([from,to]) => { out = out.replace(new RegExp(from, 'g'), to); });
    out = out.replace(/[^a-z0-9\s\-\/]/g,' ').replace(/[\-\/]+/g,' ').replace(/\s+/g,' ').trim();
    return out;
  }
  function categoryTokens(q){
    return cleanQueryForCategory(q).split(/\s+/).filter(Boolean).filter(t => !YF_STOP_WORDS.has(t)).map(singularToken);
  }
  function detectCondition(q){
    const clean = cleanQueryForCategory(q);
    if(/\b(used|pre owned|preowned|second hand)\b/.test(clean)) return 'used';
    if(/\b(new|brand new)\b/.test(clean)) return 'new';
    return 'any';
  }
  function editDistance(a,b){
    a=String(a||''); b=String(b||'');
    if(a===b) return 0;
    if(!a) return b.length; if(!b) return a.length;
    const dp = Array.from({length:a.length+1},(_,i)=>[i]);
    for(let j=1;j<=b.length;j++) dp[0][j]=j;
    for(let i=1;i<=a.length;i++) for(let j=1;j<=b.length;j++) dp[i][j]=Math.min(dp[i-1][j]+1, dp[i][j-1]+1, dp[i-1][j-1]+(a[i-1]===b[j-1]?0:1));
    return dp[a.length][b.length];
  }
  function wordClose(a,b){
    if(!a||!b) return false;
    if(a===b) return true;
    if(a.length < 4 || b.length < 4) return editDistance(a,b) <= 1;
    return editDistance(a,b) <= 2;
  }
  function keywordScore(rawQuery, keyword){
    const q = cleanQueryForCategory(rawQuery), k = cleanQueryForCategory(keyword);
    if(!q || !k) return 0;
    if(q === k) return 100;
    if(q.includes(k)) return 70 + k.split(/\s+/).length * 5;
    if(k.includes(q)) return 60 + q.split(/\s+/).length * 5;
    const qt = categoryTokens(q), kt = categoryTokens(k);
    if(!qt.length || !kt.length) return 0;
    let hits = 0;
    kt.forEach(w => { if(qt.some(t => wordClose(t,w))) hits++; });
    const coverage = hits / Math.max(kt.length,1);
    return hits ? Math.round(30 + coverage * 45) : 0;
  }
  function makeCollections({singleUrl,newUrl,usedUrl}, condition){
    const out=[];
    const add = (label, url) => {
      if(!url) return;
      const h = canonicalCollectionHandle(url);
      out.push({label:label, collectionHandle:h, collectionUrl:'/collections/' + h});
    };
    if(singleUrl) add('Best', singleUrl);
    else if(condition === 'used' && usedUrl) add('Used', usedUrl);
    else if(condition === 'new' && newUrl) add('New', newUrl);
    else { add('New', newUrl); add('Used', usedUrl); }
    return out;
  }
  function rule(label, title, keywords, urls, selectorHandle, selector={}){
    return {label, title, terms:keywords, keywords, category:selector.category || title, selectorHandle:selectorHandle || '', selectorAllow:selector.allow || [], selectorBlock:selector.block || [], collectionsBase:urls};
  }
  const YF_REFERRING_COLLECTION_RULES = [
    rule('furnace','Furnaces & Replacement Parts',['furnace','furnaces','furnace thermostat','furnace ducting','register','furnace access door','suburban furnace','atwood furnace'],{singleUrl:'/collections/new-used-rv-furnaces-replacement-parts'},'new-used-rv-furnaces-replacement-parts',{category:'Furnace',allow:['furnace','suburban','atwood','nt series','sf series']}),
    rule('refrigerator','Refrigerators & Replacement Parts',['fridge','fridges','refrigerator','refrigerators','refer','cooling unit','fridge roof vent','fridge access door','dometic refrigerator','norcold refrigerator'],{singleUrl:'/collections/new-used-rv-refrigerators-replacement-parts'},'new-used-rv-refrigerators-replacement-parts',{category:'Refrigerator',allow:['refrigerator','dometic','norcold','rm series','ndr']}),
    rule('air-conditioner','Air Conditioners & Replacement Parts',['air conditioner','airconditioner','air conditioners','a/c','ac','shroud','ceiling assembly','ac thermostat','ac ducting','coleman ac','dometic ac'],{singleUrl:'/collections/new-used-rv-air-conditioners-replacement-parts'},'new-used-rv-air-conditioners-replacement-parts',{category:'Air Conditioner',allow:['air conditioner','coleman','dometic','duotherm']}),
    rule('water-heater','Hot Water Heaters',['water heater','waterheater','hot water heater','hot water heaters','water heater door','water heater bypass','anode rod','sw6','gc6','g6a'],{singleUrl:'/collections/new-used-rv-hot-water-heaters'},'new-used-rv-hot-water-heaters',{category:'Water Heater',allow:['water heater','atwood','suburban','gc','sw','g6a']}),
    rule('microwave','Microwaves & Parts',['microwave','microwaves','microwave part'],{singleUrl:'/collections/new-rv-microwaves-parts'},'new-rv-microwaves-parts',{category:'Microwave'}),
    rule('range-oven','Ranges, Ovens & Cooktops',['oven','ovens','stove','stoves','cooktop','range hood','range hood vent','bifold cover','range parts'],{newUrl:'/collections/new-rv-ranges-ovens-range-hoods-replacement-parts',usedUrl:'/collections/used-ovens-ranges-hood-fans-parts'},'new-rv-ranges-ovens-range-hoods-replacement-parts',{category:'Range'}),
    rule('vacuum','RV Vacuum Cleaners & Accessories',['vacuum','central vacuum','vacuum cleaner','vacuum accessory','vacuum parts','dometic vacuum','dirt devil'],{singleUrl:'/collections/rv-vacuum-cleaners-accessories'},'rv-vacuum-cleaners-accessories',{category:'Central Vacuum Systems',allow:['vacuum'],block:['fresh water','waste water','water pump']}),
    rule('washer-dryer','RV Washers & Dryers',['washer','washers','dryer','dryers','washer dryer','washer dryer combo'],{singleUrl:'/collections/rv-washers-dryers'},'rv-washers-dryers',{category:'Washers & Dryers'}),
    rule('fireplace','RV Fireplaces',['fireplace','fireplaces','fire place','fireplace part'],{singleUrl:'/collections/new-used-rv-fireplaces'},'',{}),
    rule('water-pump','Water Pumps & Accessories',['water pump','water pumps','fresh water pump','waste water pump','pump fitting','pump filter','pump parts'],{newUrl:'/collections/pompes-et-accessoires',usedUrl:'/collections/used-water-pumps-parts'},'pompes-et-accessoires',{category:'Pumps',allow:['fresh water','waste water','flojet','jabsco','shurflo','shur flo','remco','thetford','wfco','lippert'],block:['vacuum','central vacuum','dometic vacuum']}),
    rule('fresh-water','Fresh Water Accessories',['water inlet','water fitting','water hose','water filter','water cleaner','fresh water accessory'],{newUrl:'/collections/fresh-water-accessories',usedUrl:'/collections/used-rv-access-hatches-doors'},'',{}),
    rule('water-tank','RV Water & Holding Tanks',['fresh water tank','grey water tank','gray water tank','black water tank','holding tank'],{newUrl:'/collections/fresh-water-tanks',usedUrl:'/collections/used-rv-holding-tanks'},'',{}),
    rule('toilet','RV Toilets & Accessories',['toilet','toilets','toilet part','toilet chemical','toilet paper','thetford toilet','aqua magic'],{newUrl:'/collections/toilets-accessories',usedUrl:'/collections/used-toilets'},'toilets-accessories',{category:'Toilets'}),
    rule('faucet','Faucets & Shower Fixtures',['faucet','faucets','shower head','shower hose','outdoor shower','faucet replacement'],{newUrl:'/collections/faucets-shower-fixtures',usedUrl:'/collections/used-faucets'},'faucets-shower-fixtures',{category:'Faucet'}),
    rule('sewer','Sewer & Sanitation Parts',['sewer','sewer hose','sewer fitting','waste valve','hose support','sewer chemical','sanitation vent','toilet rinser'],{singleUrl:'/collections/sanitation'},'sanitation',{category:'Waste Valve'}),
    rule('bath','Bath Tubs, Showers & Sinks',['bath tub','bathtub','tub surround','sink','sink part','shower surround'],{newUrl:'/collections/new-rv-bath-tubs-showers-sinks',usedUrl:'/collections/used-sinks'},'',{}),
    rule('vent','Vents, Roof Fans & Skylights',['vent','vents','roof vent','roof fan','vent cover','vent lid','skylight','escape hatch','exterior vent','vent installation'],{newUrl:'/collections/ventilation-products',usedUrl:'/collections/used-vents-skylights'},'ventilation-products',{category:'Vents'}),
    rule('roofing','RV Roofing & Sealants',['roofing','roof sealant','sealant','caulking','butyl tape','putty tape','roof product'],{singleUrl:'/collections/rv-roofing-sealants-1'},'',{}),
    rule('maintenance','RV Maintenance Products',['maintenance','rv cleaner','cleaner','protector','slide out conditioner','slide lubricant','underbelly tape','carpet protector','spray paint'],{singleUrl:'/collections/rv-maintenance-products'},'',{}),
    rule('door','RV Doors & Storage Parts',['entry door','rv door','storage door','baggage door','cargo door','door lock','door holder','entry door window'],{newUrl:'/collections/new-rv-doors-storage-parts',usedUrl:'/collections/used-exterior-windows-doors'},'',{}),
    rule('stabilizer','Stabilizers & Landing Gear',['stabilizer','stabilizers','landing gear','jack','jacks','camper jack','wheel chock','leveler','fifth wheel king pin'],{newUrl:'/collections/rv-stabilizers',usedUrl:'/collections/used-stabilizers-landing-gear'},'rv-stabilizers',{category:'Leveling Systems'}),
    rule('step','RV Steps & Parts',['step','steps','electric step','step parts','step accessory'],{newUrl:'/collections/steps',usedUrl:'/collections/used-steps-replacement-parts'},'steps',{category:'Steps'}),
    rule('slide-out','Slide-Out Parts & Accessories',['slide out','slideout','slide motor','slide gear','slide electronics','slide seal','slide moulding','slide extrusion'],{newUrl:'/collections/slide-out-parts-accessories',usedUrl:'/collections/used-slide-parts'},'SLIDEOUTS',{category:'Slideouts'}),
    rule('propane','Propane Parts & Accessories',['propane','propane alarm','smoke detector','carbon monoxide detector','regulator','propane hose','propane fitting','propane tank','propane cover','propane gauge'],{newUrl:'/collections/new-rv-propane-parts-accessories',usedUrl:'/collections/used-propane'},'',{}),
    rule('lighting','RV Lighting',['lighting','light','lights','interior light','exterior light','wall switch','wall receptacle','bulb','marker light','tail light'],{newUrl:'/collections/new-rv-lighting',usedUrl:'/collections/used-rv-lights'},'',{}),
    rule('window','RV Windows',['window','windows','window part','window hardware','blind','blind hardware','curtain hardware'],{newUrl:'/collections/new-rv-windows',usedUrl:'/collections/used-windows'},'',{}),
    rule('cover','RV Covers',['rv cover','tire cover','propane cover','wheel cover'],{singleUrl:'/collections/rv-covers'},'',{}),
    rule('ladder','RV Ladders & Bike Racks',['ladder','ladders','bunk ladder','ladder part','bike rack'],{singleUrl:'/collections/new-rv-ladders-bunk-ladders'},'',{}),
    rule('fender-skirt','Fender Skirts',['fender skirt','wheel skirt'],{singleUrl:'/collections/fender-skirt-replacement-parts'},'',{}),
    rule('moulding','RV Mouldings & Exterior Trim',['vinyl trim','skew cover','screw cover','awning gutter','exterior moulding','moulding','molding'],{singleUrl:'/collections/mouldings'},'',{}),
    rule('cabinet-hardware','Cabinet & Drawer Hardware',['cabinet','cabinet hardware','drawer hardware','bunk bed clamp','interior hinge','interior knob','cupboard hardware'],{newUrl:'/collections/new-rv-drawer-cabinet-hardware',usedUrl:'/collections/used-rv-drawer-cabinet-hardware'},'',{}),
    rule('table','RV Tables & Hardware',['table','table hardware','table base','table leg','table mount'],{newUrl:'/collections/new-rv-tables-hardware',usedUrl:'/collections/used-rv-tables-hardware'},'new-rv-tables-hardware',{category:'Portable Waste Tank',allow:['table'],block:['waste tank']}),
    rule('interior-door','Interior Doors & Hardware',['interior door','closet door','sliding door','fabric door','interior door knob','interior door hardware'],{newUrl:'/collections/new-rv-interior-door-hardware',usedUrl:'/collections/used-rv-interior-doors-hardware'},'',{}),
    rule('kitchen','Kitchen Accessories',['kitchen accessory','kitchen accessories','cuisine'],{singleUrl:'/collections/cuisine'},'',{}),
    rule('converter','Converters & Inverters',['converter','inverter','converter door','power distribution center','breaker','fuse panel'],{newUrl:'/collections/new-rv-converters-inverters',usedUrl:'/collections/used-converters-inverters-parts'},'new-rv-converters-inverters',{category:'Converter'}),
    rule('electrical','Electrical Exterior Accessories',['electrical cord','extension cord','power cord','surge protector','adapter','adaptor','plug cover','outlet box','receptacle','power inlet'],{newUrl:'/collections/rallonges-et-adaptateurs-electriques-pour-vr',usedUrl:'/collections/used-cords-receptacles'},'',{}),
    rule('battery','Battery Accessories',['battery','batteries','battery accessory','battery disconnect'],{newUrl:'/collections/batteries-accessories',usedUrl:'/collections/used-batteries-accessories'},'batteries-accessories',{category:'Battery Disconnect'}),
    rule('solar','Solar Parts',['solar','solar charger','solar panel','charge controller'],{newUrl:'/collections/chargeurs-solaires-et-accessoires',usedUrl:'/collections/used-solar-chargers'},'chargeurs-solaires-et-accessoires',{category:'Solar Panel'}),
    rule('generator','Generators & Parts',['generator','generators','onan','cummins generator'],{singleUrl:'/collections/rv-generators-parts'},'rv-generators-parts',{category:'Generators'}),
    rule('radio','Radios, Antennas & Satellites',['radio','speaker','speakers','antenna','satellite'],{newUrl:'/collections/new-rv-radios-antennas-satellites',usedUrl:'/collections/used-radios-satellites'},'new-rv-radios-antennas-satellites',{category:'Antenna'}),
    rule('tank-monitor','Tank Monitors',['tank monitor','monitor panel'],{newUrl:'/collections/new-rv-tank-monitors',usedUrl:'/collections/used-tank-monitors'},'new-rv-tank-monitors',{category:'Monitor Panel'}),
    rule('awning','Awnings & Replacement Parts',['awning','awnings','awning parts','awning arm','awning hardware','carefree awning','awning replacement parts','awning hardware parts'],{newUrl:'/collections/new-rv-awnings-replacement-parts-accessories',usedUrl:'/collections/used-awnings'},'mouldings',{category:'Awning',allow:['awning','a&e','dometic','carefree','lippert','solera','weather pro','sunchaser','8500','9000','9500','one step','two step']}),
    rule('furniture','RV Furniture',['furniture','chair','chairs','mattress','rv mattress'],{newUrl:'/collections/new-rv-furniture-chairs-mattresses',usedUrl:'/collections/used-rv-furniture'},'',{}),
    rule('camping','Camping Accessories',['camping accessory','camping accessories'],{singleUrl:'/collections/accessoires-de-camping'},'',{}),
    rule('motorhome-body','Motorhome Body Parts',['motorhome body','motorhome part','motorhome parts'],{singleUrl:'/collections/used-rv-motorhome-parts'},'',{}),
    rule('tire-wheel','RV Rims & Tires',['tire','tires','rim','rims','hub cap','hub caps','wheel'],{singleUrl:'/collections/used-rv-rims-tires'},'',{}),
    rule('skirting','RV Skirting & Underbelly',['skirting','underbelly','belly wrap','coroplast','winter skirting','underbelly insulation'],{singleUrl:'/collections/rv-skirting-underbelly'},'',{}),
    rule('access-hatch','RV Access Hatches & Doors',['access hatch','utility hatch','service hatch','water hatch','cable hatch','electrical hatch','access panel'],{newUrl:'/collections/new-rv-access-hatches-doors',usedUrl:'/collections/used-rv-access-hatches-doors'},'',{}),
    rule('exterior-hardware','RV Exterior Hardware',['exterior bracket','mounting bracket','corner bracket','exterior support','exterior hardware'],{singleUrl:'/collections/rv-exterior-hardware'},'',{})
  ];
  function scoreRuleForQuery(rule, q){
    let best = 0;
    (rule.terms || rule.keywords || []).forEach(t => { best = Math.max(best, keywordScore(q,t)); });
    return best;
  }
  function allReferringRulesForQuery(q){
    const condition = detectCondition(q);
    let matches = YF_REFERRING_COLLECTION_RULES.map(r => {
      const score = scoreRuleForQuery(r,q);
      if(score < 40) return null;
      const clone = Object.assign({}, r);
      clone.score = score;
      clone.conditionHint = condition;
      clone.collections = makeCollections(r.collectionsBase || {}, condition).map(c => Object.assign({}, c, {displayName:c.displayName || r.title, categoryGroup:r.category || r.title}));
      return clone;
    }).filter(Boolean).sort((a,b)=>b.score-a.score);

    // V35: if the query clearly matches one curated category (ex: water pump), do not show weak
    // shared-word categories (ex: hot water heater) just because they also contain "water".
    // For mixed intent searches such as "slide out vent", the top scores are close enough to keep both.
    if(matches.length){
      const top = matches[0].score || 0;
      if(top >= 95) matches = matches.filter(m => (m.score || 0) >= 85);
      else if(top >= 75) matches = matches.filter(m => (m.score || 0) >= Math.max(40, top - 20));
    }
    return matches;
  }
  function referringRuleForQuery(q){ return allReferringRulesForQuery(q)[0] || null; }

  function canonicalCollectionHandle(input){
    let h = String(input || '').trim().replace(/^\/collections\//,'').replace(/^https?:\/\/[^/]+\/collections\//,'').replace(/\?.*$/,'').replace(/^\/+|\/+$/g,'');
    if(YF_COLLECTION_ALIASES[h]) h = YF_COLLECTION_ALIASES[h];
    const key = norm(h);
    if(YF_CATEGORY_TO_COLLECTION[key]) h = YF_CATEGORY_TO_COLLECTION[key];
    return h;
  }

  // V49: Only send customers directly to collection URLs that are known canonical Shopify handles.
  // Unknown or guessed handles fall back to Shopify search instead of ever visiting /collections/{guess}.
  const YF_VERIFIED_COLLECTION_HANDLES = new Set([
    'pompes-et-accessoires','used-water-pumps-parts','new-used-rv-hot-water-heaters','new-used-rv-refrigerators-replacement-parts','new-used-rv-furnaces-replacement-parts','new-used-rv-air-conditioners-replacement-parts','new-rv-microwaves-parts','new-rv-ranges-ovens-range-hoods-replacement-parts','used-ovens-ranges-hood-fans-parts','rv-vacuum-cleaners-accessories','rv-washers-dryers','new-used-rv-fireplaces','fresh-water-accessories','used-rv-access-hatches-doors','fresh-water-tanks','used-rv-holding-tanks','toilets-accessories','used-toilets','faucets-shower-fixtures','used-faucets','sanitation','new-rv-bath-tubs-showers-sinks','used-sinks','ventilation-products','used-vents-skylights','rv-roofing-sealants-1','rv-maintenance-products','new-rv-doors-storage-parts','used-exterior-windows-doors','rv-stabilizers','used-stabilizers-landing-gear','steps','used-steps-replacement-parts','slide-out-parts-accessories','used-slide-parts','new-rv-propane-parts-accessories','used-propane','new-rv-lighting','used-rv-lights','new-rv-windows','used-windows','rv-covers','new-rv-ladders-bunk-ladders','fender-skirt-replacement-parts','mouldings','new-rv-drawer-cabinet-hardware','used-rv-drawer-cabinet-hardware','new-rv-tables-hardware','used-rv-tables-hardware','new-rv-interior-door-hardware','used-rv-interior-doors-hardware','cuisine','new-rv-converters-inverters','used-converters-inverters-parts','rallonges-et-adaptateurs-electriques-pour-vr','used-cords-receptacles','batteries-accessories','used-batteries-accessories','chargeurs-solaires-et-accessoires','used-solar-chargers','rv-generators-parts','new-rv-radios-antennas-satellites','used-radios-satellites','new-rv-tank-monitors','used-tank-monitors','new-rv-awnings-replacement-parts-accessories','used-awnings','new-rv-furniture-chairs-mattresses','used-rv-furniture','accessoires-de-camping','used-rv-motorhome-parts','used-rv-rims-tires','rv-skirting-underbelly','new-rv-access-hatches-doors','rv-exterior-hardware'
  ]);
  function verifiedCollectionUrl(handle){
    const h = canonicalCollectionHandle(handle || '');
    return (h && YF_VERIFIED_COLLECTION_HANDLES.has(h)) ? '/collections/' + h : '';
  }

  function collectionHref(c){
    const raw = c && (c.collectionUrl || c.url || c.collectionHandle || c.handle);
    const h = canonicalCollectionHandle(raw);
    const verified = verifiedCollectionUrl(h);
    if(verified) return verified;
    const q = (c && (c.displayName || c.keyword || c.categoryGroup)) || (h ? h.replace(/-/g,' ') : 'rv parts');
    return nativeSearchUrl(q);
  }
  function normalizeCollectionRecord(c){
    if(!c) return null;
    const copy = Object.assign({}, c);
    copy.collectionHandle = canonicalCollectionHandle(copy.collectionHandle || copy.handle || copy.collectionUrl || copy.url || '');
    if(!copy.collectionHandle){
      const key = norm(copy.displayName || copy.keyword || copy.categoryGroup || '');
      copy.collectionHandle = YF_CATEGORY_TO_COLLECTION[key] || '';
    }
    if(copy.collectionHandle) copy.collectionUrl = '/collections/' + copy.collectionHandle;
    return copy;
  }

  function titleFromCollection(c){
    c = normalizeCollectionRecord(c) || {};
    const h = c.collectionHandle || '';
    const special = {
      'new-used-rv-hot-water-heaters':'New & Used RV Hot Water Heaters',
      'new-used-rv-refrigerators-replacement-parts':'New & Used RV Refrigerators & Replacement Parts',
      'new-used-rv-furnaces-replacement-parts':'New & Used RV Furnaces & Replacement Parts',
      'new-rv-air-conditioners-replacement-parts':'New RV Air Conditioners & Replacement Parts',
      'new-rv-awnings-replacement-parts-accessories':'New RV Awnings, Replacement Parts & Accessories',
      'pompes-et-accessoires':'Pumps & Accessories',
      'used-water-pumps-parts':'Used RV Water Pumps & Parts',
      'used-rv-rims-tires':'RV Rims & Tires',
      'rv-covers':'RV Covers',
      'rv-vacuum-cleaners-accessories':'RV Vacuum Cleaners & Accessories',
      'new-rv-ladders-bunk-ladders':'New RV Ladders & Bunk Ladders'
    };
    if(special[h]) return special[h];
    if(c.displayName && !/^[a-z_]+$/.test(String(c.displayName))) return c.displayName;
    return (h || c.displayName || c.keyword || 'Recommended Collection').replace(/-/g,' ').replace(/\bnew used\b/i,'New & Used').replace(/\brv\b/ig,'RV').replace(/\b\w/g,m=>m.toUpperCase());
  }
  async function primaryCollection(q, model, part){
    // V34: use the curated/referring-links category engine before the old static collection index.
    // This catches fuzzy category searches like ladder, ladders, water pups, water pumps, etc.
    if(!model && !part){
      const r = referringRuleForQuery(q);
      if(r && r.collections && r.collections.length) return normalizeCollectionRecord(r.collections[0]);
    }
    if(model){
      if(model.newCol) return normalizeCollectionRecord({displayName:model.colName || cleanCategoryName(model.c) || 'Recommended Collection', collectionHandle:model.newCol, categoryGroup:model.c || model.af || ''});
      if(model.usedCol) return normalizeCollectionRecord({displayName:model.colName || cleanCategoryName(model.c) || 'Recommended Collection', collectionHandle:model.usedCol, categoryGroup:model.c || model.af || ''});
    }
    if(part){
      for(const u of ((part.used) || []).slice(0,20)){ const m = await db.model(u && u[0]); const c = await primaryCollection(q, m, null); if(c) return c; }
    }
    const col = await db.collection(); const k = norm(q); let best = null, bestScore = 0;
    Object.keys(col).forEach(key => { const c = col[key]; const hay = key + ' ' + norm(c.keyword) + ' ' + norm(c.displayName) + ' ' + (c.synonyms || []).map(norm).join(' '); let score = 0; if(hay.includes(k) || k.includes(key)) score = Math.max(key.length, k.length); if(score > bestScore && c.collectionHandle){ best = normalizeCollectionRecord(c); bestScore = score; } });
    return best;
  }

  function friendlyDiagramTitle(d, model){
    const b = (d && d.b) || (model && model.b) || ''; const m = (d && d.m) || (model && model.m) || '';
    let t = [b, m].filter(Boolean).join(' ');
    if(!t) t = 'Breakdown Diagram'; else t += ' Breakdown Diagram';
    if(d && d.s) t += ' · Serial ' + d.s;
    return t;
  }
  function diagramSubtext(d){ return [(d && d.c) ? cleanCategoryName(d.c) : '', (d && d.s) ? 'Serial ' + d.s : 'All serials / no serial split'].filter(Boolean).join(' • '); }
  function diagramThumb(d, alt){ return d && d.url ? '<div class="yf-diagram-thumb"><img loading="lazy" src="'+esc(d.url)+'" alt="'+esc(alt || 'Breakdown diagram')+'"></div>' : '<div class="yf-diagram-thumb empty">Diagram</div>'; }

  function serialMatches(a,b){
    const aa = norm(a), bb = norm(b);
    if(!bb) return true;
    if(!aa) return false;
    // V54: Serial filters must be exact after normalization.
    // Selecting N611 must not include N611C, N611F, N611V, etc.
    // The old contains-based match was only helpful for loose searching, but
    // selected serial/production range pages must show that exact serial only.
    return aa === bb;
  }
  function isPlaceholderDiagram(d){
    const hay = String((d && (d.bn || d.img || d.url || d.id)) || '').toLowerCase();
    return hay.includes('dinologo') || hay.includes('placeholder') || hay.includes('no-image');
  }
  function displayDiagrams(diagrams){
    // V29: Do not drop DinoLogo/secondary diagram records.
    // Some models use those records as legitimate individual breakdowns,
    // so the customer must see every diagram connected to the model/serial.
    return (diagrams || []).filter(Boolean);
  }
  function diagramsForModel(model, serial){
    let diagrams = (model && (model._allDiagrams || model.diagrams) || []);
    if(serial) diagrams = diagrams.filter(d => serialMatches(d && d.s, serial));
    return displayDiagrams(diagrams);
  }
  function breakdownDisplayName(d, model, index){
    const n = Number.isFinite(index) ? (index + 1) : 1;
    return 'Breakdown ' + n;
  }
  function diagramCard(d, model, index, currentId){
    const name = breakdownDisplayName(d, model, index);
    const active = currentId && d && d.id === currentId ? ' active' : '';
    const serial = d && d.s ? 'Serial ' + d.s : 'All serials';
    return '<a class="yf-diagram-preview yf-diagram-preview-compact'+active+'" href="'+diagramUrl(d.id)+'">'
      + diagramThumb(d, name)
      + '<div class="yf-diagram-copy"><strong>'+esc(name)+'</strong><span>'+esc(serial)+'</span></div></a>';
  }
  function diagramGrid(diagrams, model, empty, currentId){
    diagrams = diagrams || [];
    if(!diagrams.length) return '<div class="yf-empty-state">'+esc(empty || 'No breakdown diagrams found.')+'</div>';
    return '<div class="yf-diagram-row all">'+diagrams.map((d,i)=>diagramCard(d,model,i,currentId)).join('')+'</div>';
  }
  function partNumbersFromDiagrams(diagrams){
    const seen = new Set(), out = [];
    (diagrams || []).forEach(d => (d.parts || []).forEach(x => {
      const pn = x && x[1]; const k = norm(pn);
      if(k && !seen.has(k)){ seen.add(k); out.push(pn); }
    }));
    return out;
  }

  function productCard(p, opts={}){
    const handle = p.handle || ''; const url = p.url || ('/products/' + handle);
    const badge = opts.badge || p._label || '';
    const condition = opts.showCondition ? yfPartInfoCondition(p) : '';
    return '<a class="yf-product-card yf-product-card-clickable" data-yf-product-card data-handle="'+esc(handle)+'" href="'+esc(url)+'" aria-label="View '+esc(p.title || 'product')+'">'
      + '<div class="yf-product-image" data-yf-product-img>' + (p.imageUrl ? '<img loading="lazy" src="'+esc(p.imageUrl)+'" alt="'+esc(p.title||'Product image')+'">' : '<span>No image</span>') + '</div>'
      + '<div class="yf-product-body">'
      + '<div class="yf-product-badge-row">'
      + (badge ? '<span class="yf-product-badge '+esc(opts.badgeClass || p._klass || '')+'">'+esc(badge)+'</span>' : '')
      + (condition ? '<span class="yf-product-condition-badge '+(condition === 'Used' ? 'used' : 'new')+'">'+esc(condition)+'</span>' : '')
      + '</div>'
      + '<h3>'+esc(p.title || handle || 'Product')+'</h3>'
      + '<div class="yf-chip-row">' + (p.partNumber ? '<span>Part '+esc(p.partNumber)+'</span>' : '') + (opts.matchedPart || p._matchedPart ? '<span>Matched '+esc(opts.matchedPart || p._matchedPart)+'</span>' : '') + '</div>'
      + '<div class="yf-price-row"><strong data-yf-product-price>'+esc(money(p.price||''))+'</strong><small data-yf-product-compare>' + (p.compareAtPrice && Number(p.compareAtPrice) > Number(p.price) ? '<s>'+esc(money(p.compareAtPrice))+'</s>' : '') + '</small></div>'
      + '<div class="yf-stock" data-yf-product-availability>In stock</div>'
      + '<div class="yf-card-actions"><span class="yf-btn">View Product</span></div>'
      + '</div></a>';
  }

  async function hydrateProducts(scope){
    const cards = [...scope.querySelectorAll('[data-yf-product-card]')].slice(0,120);
    await mapLimit(cards, 8, async card => {
      const handle = card.getAttribute('data-handle'); if(!handle || card.dataset.hydrated) return; card.dataset.hydrated = '1';
      const j = await shopifyProduct(handle); if(!j) return;
      const img = card.querySelector('[data-yf-product-img]'); const src = productImage(j); if(img && src) img.innerHTML = '<img loading="lazy" src="'+esc(src)+'" alt="'+esc(j.title||'Product image')+'">';
      const v = bestVariant(j);
      const price = card.querySelector('[data-yf-product-price]'); if(price && v && v.price != null) price.textContent = money(v.price);
      const compare = card.querySelector('[data-yf-product-compare]'); if(compare && v && v.compare_at_price && v.compare_at_price > v.price) compare.innerHTML = '<s>'+esc(money(v.compare_at_price))+'</s>';
      const avail = card.querySelector('[data-yf-product-availability]'); if(avail && v){ avail.textContent = v.available ? 'In stock' : 'Out of stock'; avail.classList.toggle('red', !v.available); }
    });
  }

  function collectionCard(c, label){
    c = normalizeCollectionRecord(c) || {};
    const url = collectionHref(c); const title = titleFromCollection(c); const group = cleanCategoryName(c.categoryGroup || c.displayName || c.keyword || '');
    const kicker = label || c.label || 'Best collection';
    const img = c.imageUrl || c.image || (c.featuredImage && c.featuredImage.url) || '';
    // V41: The actual href is intentionally safe Shopify search. JS resolves to the real
    // collection URL on click. If JS fails/caches, the customer still never lands on a 404.
    const safeHref = verifiedCollectionUrl(c.collectionHandle) || nativeSearchUrl(title || group || 'rv parts');
    return '<a class="yf-collection-card" data-yf-collection-card data-handle="'+esc(c.collectionHandle||'')+'" data-fallback-q="'+esc(title || group || 'rv parts')+'" href="'+esc(safeHref)+'">'
      + '<div class="yf-collection-img" data-yf-collection-img>'+(img ? '<img loading="lazy" src="'+esc(img)+'" alt="'+esc(title)+'">' : '<span>Collection</span>')+'</div><div class="yf-collection-copy"><div class="yf-kicker">'+esc(kicker)+'</div><h3>'+esc(title)+'</h3>' + (group ? '<p>'+esc(group)+'</p>' : '') + '</div></a>';
  }
  async function hydrateCollectionCards(scope){
    const cards = [...scope.querySelectorAll('[data-yf-collection-card]')];
    await mapLimit(cards, 4, async card => {
      if(card.dataset.collectionImgHydrated) return;
      const h = card.getAttribute('data-handle');
      const img = await collectionImage(h);
      const box = card.querySelector('[data-yf-collection-img]');
      if(box && img) box.innerHTML = '<img loading="lazy" src="'+esc(img)+'" alt="Collection image">';
      card.dataset.collectionImgHydrated = '1';
    });
  }


  function collectionResultsFromSuggest(j){
    const r = j && j.resources && j.resources.results;
    return (r && (r.collections || r.collection)) || [];
  }
  async function resolveCollectionUrl(handle, fallbackQ){
    const h = canonicalCollectionHandle(handle || '');

    // V49: If the handle is in our verified canonical list, go directly there.
    // If it is not verified, never visit /collections/{guess}; use Shopify suggestions or search.
    const verified = verifiedCollectionUrl(h);
    if(verified) return verified;

    const qList = [];
    if(fallbackQ) qList.push(fallbackQ);
    if(h) qList.push(h.replace(/-/g,' '));
    for(const q of qList){
      try{
        const r = await fetch('/search/suggest.json?q=' + enc(q) + '&resources[type]=collection&resources[limit]=10', {credentials:'same-origin'});
        if(!r.ok) continue;
        const j = await r.json();
        const cols = collectionResultsFromSuggest(j);
        if(cols && cols.length){
          const nq = norm(q);
          const best = cols.find(c => c && c.url && norm(c.title || '') === nq)
            || cols.find(c => c && c.url && (norm(c.title || '').includes(nq) || nq.includes(norm(c.title || ''))))
            || cols[0];
          if(best && best.url) return best.url;
        }
      }catch(e){}
    }

    // Do not fall back to unverified /collections/{handle}; that was the 404 source.
    return nativeSearchUrl(fallbackQ || (h ? h.replace(/-/g,' ') : 'rv parts'));
  }
  async function initCollectionLinkSafety(scope){
    scope.querySelectorAll('[data-yf-collection-card]').forEach(card => {
      if(card.dataset.collectionSafeBound) return;
      card.dataset.collectionSafeBound = '1';
      card.addEventListener('click', async function(e){
        const href = card.getAttribute('href') || '';
        const h = canonicalCollectionHandle(card.getAttribute('data-handle') || '');
        if(!h) return;
        e.preventDefault();
        const title = card.getAttribute('data-fallback-q') || (card.querySelector('h3') && card.querySelector('h3').textContent) || h.replace(/-/g,' ');
        location.href = await resolveCollectionUrl(h, title);
      });
    });
  }


  function collectionsFromRule(rule){
    return (rule && rule.collections ? rule.collections : []).map(normalizeCollectionRecord).filter(Boolean);
  }
  async function collectionsForQuery(q, model, part, primary){
    if(model || part) return primary ? [normalizeCollectionRecord(primary)] : [];
    const rules = allReferringRulesForQuery(q).slice(0,4);
    if(rules.length){
      const out=[], seen=new Set();
      rules.forEach(rule => collectionsFromRule(rule).forEach(c => {
        const h = canonicalCollectionHandle(c && c.collectionHandle);
        if(h && !seen.has(h)){ seen.add(h); out.push(c); }
      }));
      return out;
    }
    return primary ? [normalizeCollectionRecord(primary)] : [];
  }
  async function categoryInfoForSearch(q, collections){
    const idx = await db.categoryModels();
    const rule = referringRuleForQuery(q);
    if(rule && rule.selectorHandle){
      const h = canonicalCollectionHandle(rule.selectorHandle);
      if(idx[h]) return Object.assign({}, idx[h], {_yfRuleLabel:rule.label});
    }
    const handles = (collections || []).map(c => canonicalCollectionHandle(c && c.collectionHandle)).filter(Boolean);
    for(const h of handles){ if(idx[h]) return idx[h]; }
    // If a curated category was found but does not have a trusted selector handle, do not guess a selector from a broad category.
    // This prevents categories such as mouldings from accidentally showing awning breakdowns.
    if(rule) return null;
    const nq = norm(q);
    const values = Object.values(idx || {});
    let best = null, bestScore = 0;
    for(const c of values){
      const hay = [c.collectionHandle, c.displayName, c.category].map(norm).join(' ');
      let score = 0;
      if(nq && (hay.includes(nq) || nq.includes(norm(c.displayName || c.category || '')))) score += 30;
      if(score > bestScore){ best = c; bestScore = score; }
    }
    return bestScore >= 30 ? best : null;
  }
  function categoryCollectionsPanel(collections){
    if(!collections || !collections.length) return '';
    const cards = collections.map(c => collectionCard(c, c.label || (collections.length > 1 ? 'Collection' : 'Best collection'))).join('');
    return '<section class="yf-panel yf-category-collections"><div class="yf-panel-head"><div><h2>Browse collections</h2></div><strong>'+esc(collections.length)+'</strong></div><div class="yf-collection-grid">'+cards+'</div></section>';
  }
  function suggestedCollectionsPanel(collections, title, copy){
    collections = (collections || []).map(normalizeCollectionRecord).filter(Boolean);
    if(!collections.length) return '';
    const seen = new Set();
    collections = collections.filter(c => { const h = canonicalCollectionHandle(c.collectionHandle); if(!h || seen.has(h)) return false; seen.add(h); return true; });
    if(!collections.length) return '';
    return '<section class="yf-panel yf-suggested-collections"><div class="yf-panel-head"><div><h2>'+esc(title || 'Recommended collections')+'</h2>'+(copy?'<p>'+esc(copy)+'</p>':'')+'</div><strong>'+esc(collections.length)+'</strong></div><div class="yf-collection-grid">'+collections.map(c => collectionCard(c, c.label || 'Recommended')).join('')+'</div></section>';
  }
  function categorySearchIntro(q, rule, collections){
    const title = (rule && rule.title) || (collections && collections[0] && titleFromCollection(collections[0])) || cleanCategoryName(q);
    return '<section class="yf-match-hero yf-category-hero"><div><div class="yf-kicker">Category match</div><h2>'+esc(title)+'</h2><p>Browse matching collections, or choose your manufacturer and model to find the exact breakdown diagrams.</p></div></section>';
  }
  function categorySelectorShell(c, q){
    if(!c) return '';
    return '<div data-yf-category-widget data-collection-handle="'+esc(c.collectionHandle || '')+'" data-collection-title="'+esc(c.displayName || c.category || '')+'" data-category-query="'+esc(q || '')+'"></div>';
  }


  function queryMatchCandidates(q){
    const raw = String(q || '').toUpperCase().replace(/[^A-Z0-9]+/g, ' ').trim();
    const words = raw ? raw.split(/\s+/).filter(Boolean) : [];
    const candidates = [];
    const add = v => { const k = norm(v); if(k && k.length >= 2 && !candidates.includes(k)) candidates.push(k); };
    add(q);
    words.forEach(add);
    // Adjacent combinations catch model numbers typed with spaces, like G6A 8E, RM 2652, SW 6D.
    for(let i=0;i<words.length;i++){
      add(words[i] + (words[i+1] || ''));
      add(words[i] + (words[i+1] || '') + (words[i+2] || ''));
    }
    return candidates.sort((a,b) => b.length - a.length);
  }
  function partOrModelCandidateTokens(q){
    // V37: a database model/part match must contain a number. This prevents plain category words
    // such as "window" from matching model names like "Window Awning", while still allowing
    // embedded searches such as "suburban sw6d" to resolve to SW6D.
    return queryMatchCandidates(q).filter(x => /[0-9]/.test(x));
  }
  function shouldPreferPartMatch(q, part, model, force){
    if(force === 'part') return !!part;
    if(force === 'model') return false;
    if(!part) return false;
    if(!model) return true;
    const pn = norm(part.p || '');
    const mn = norm(model.m || model.n || '');
    const tokens = partOrModelCandidateTokens(q);
    // If the customer typed/clicked an exact part number, never let a broader model prefix
    // or nearby model like 9093100 steal the page. This fixes part dropdown clicks such as 93100.
    if(tokens.includes(pn)) return true;
    if(tokens.includes(mn)) return false;
    // Numeric-only searches are normally part-number intent unless a model is an exact match.
    if(tokens.some(t => /^[0-9]+$/.test(t) && pn.startsWith(t))) return true;
    return false;
  }
  async function bestPartForQuery(q){
    const candidates = partOrModelCandidateTokens(q);
    if(!candidates.length) return null;
    for(const c of candidates){
      const p = await db.part(c);
      if(p) return p;
    }
    // Last resort: only use prefix search on numeric-bearing tokens, never plain words.
    for(const c of candidates.filter(x => x.length >= 4)){
      const list = await db.searchPrefix('part', c, 3);
      if(list && list.length) return list.find(p => norm(p.p || '').startsWith(c)) || list[0];
    }
    return null;
  }
  function cleanManufacturerLabel(v){
    let s = String(v || '').replace(/\u00a0/g,' ').replace(/\s+/g,' ').trim();
    // Strip known series suffixes from brand label only.
    s = s.replace(/\s+(SF|NT|DD|SH|P|RM|CF|VG|SW)\s+Series$/i,'').trim();
    return s;
  }
  async function modelFromCategorySelectorToken(q){
    const candidates = partOrModelCandidateTokens(q);
    if(!candidates.length) return null;
    const idx = await db.categoryModels();
    const exact = new Set(candidates.map(norm));
    let fallback = null;
    for(const col of Object.values(idx || {})){
      const category = col && (col.category || col.displayName || '');
      const mans = (col && col.manufacturers) || {};
      for(const [manufacturerRaw, man] of Object.entries(mans)){
        const manufacturer = cleanManufacturerLabel(manufacturerRaw);
        const series = (man && man.series) || {};
        for(const [seriesKey, models] of Object.entries(series)){
          for(const m of (models || [])){
            const modelNumber = m && (m.modelNumber || m.m || '');
            const modelNorm = norm(m && (m.normalized || modelNumber || seriesKey));
            if(exact.has(modelNorm)){
              return {m:modelNumber, n:modelNorm, b:manufacturerRaw, c:category, af:category, _lookupModelKey:modelNorm, _seriesKey:seriesKey};
            }
            for(const serial of (m.serials || [])){
              const sn = norm(serial);
              if(exact.has(sn)){
                return {m:serial, n:sn, b:manufacturerRaw, c:category, af:category, _lookupModelKey:modelNorm || norm(seriesKey), _seriesKey:seriesKey, _serial:serial, _fromSerial:true};
              }
              // Prefix fallback for common furnace formats like SF20 typed against SF20F/SF20Q, but only after exact checks.
              if(!fallback && candidates.some(c => c.length >= 4 && sn.startsWith(c))){
                fallback = {m:serial, n:sn, b:manufacturerRaw, c:category, af:category, _lookupModelKey:modelNorm || norm(seriesKey), _seriesKey:seriesKey, _serial:serial, _fromSerial:true};
              }
            }
          }
        }
        // Some categories also have a flat models list.
        for(const m of ((man && man.models) || [])){
          const modelNumber = m && (m.modelNumber || m.m || '');
          const modelNorm = norm(m && (m.normalized || modelNumber));
          if(exact.has(modelNorm)) return {m:modelNumber, n:modelNorm, b:manufacturerRaw, c:category, af:category, _lookupModelKey:modelNorm};
          for(const serial of (m.serials || [])){
            const sn = norm(serial);
            if(exact.has(sn)) return {m:serial, n:sn, b:manufacturerRaw, c:category, af:category, _lookupModelKey:modelNorm, _serial:serial, _fromSerial:true};
          }
        }
      }
    }
    return fallback;
  }
  async function bestModelForQuery(q){
    const candidates = partOrModelCandidateTokens(q);
    if(!candidates.length) return null;
    for(const c of candidates){
      const m = await db.model(c);
      if(m) return m;
    }
    // Also search the category selector index. Some Suburban furnace models such as SF20/SF20F
    // are stored as serial/model variants under "SF Series" rather than as standalone model rows.
    // Customers still type them as model numbers, so promote those exact serial variants to a model match.
    const selectorModel = await modelFromCategorySelectorToken(q);
    if(selectorModel) return selectorModel;
    // Brand + model searches like "suburban sw6d" resolve through the SW6D token only.
    for(const c of candidates.filter(x => x.length >= 3)){
      const list = await db.searchPrefix('model', c, 6);
      if(list && list.length){
        return list.find(m => norm(m.m || m.n || '').startsWith(c)) || list[0];
      }
    }
    return null;
  }
  function modelSerialGroups(model){
    const groups = {}; displayDiagrams(model && (model._allDiagrams || model.diagrams) || []).forEach(d => { const s = String(d.s || '').trim(); if(!s) return; (groups[s] || (groups[s] = [])).push(d); });
    return Object.keys(groups).sort().map(s => ({serial:s, diagrams:groups[s]}));
  }
  function modelHasSerialHierarchy(model){ return modelSerialGroups(model).length > 1; }
  function serialPickerHtml(model){
    const groups = modelSerialGroups(model);
    if(!groups.length) return '';
    const id = 'yf-serial-' + norm(model.m);
    return '<section class="yf-step-card" data-yf-serial-picker data-model="'+esc(model.m)+'"><div class="yf-step-number">1</div><div class="yf-step-content"><h2>Choose your serial number first</h2><p>Different serial ranges can use different parts. Pick the serial from the appliance label so we only show the correct diagrams and products.</p><label class="yf-select-label" for="'+esc(id)+'">Serial number</label><div class="yf-serial-controls"><select id="'+esc(id)+'" data-yf-serial-select><option value="">Select serial number</option>'+groups.map(g => '<option value="'+esc(g.serial)+'">'+esc(g.serial)+'</option>').join('')+'</select><button type="button" class="yf-btn" data-yf-serial-go disabled>Show correct parts</button></div></div></section>';
  }
  function initSerialSelectors(scope){
    scope.querySelectorAll('[data-yf-serial-picker]').forEach(box => { if(box.dataset.bound) return; box.dataset.bound = '1'; const sel = box.querySelector('[data-yf-serial-select]'); const btn = box.querySelector('[data-yf-serial-go]'); const model = box.getAttribute('data-model') || ''; const go = () => { const serial = sel && sel.value; if(serial) location.href = modelBreakdownUrl(model) + '&serial=' + enc(serial); }; if(sel && btn){ sel.addEventListener('change', () => { btn.disabled = !sel.value; }); btn.addEventListener('click', go); } });
  }

  function stat(value, label, tone){
    let safeValue;
    if(value && value.__html){ safeValue = value.__html; }
    else safeValue = esc(value == null || value === '' ? '—' : value);
    return '<div class="yf-stat '+(tone||'')+'"><strong>'+safeValue+'</strong><span>'+esc(label)+'</span></div>';
  }
  function modelDatabasePartCount(model){
    const seen = new Set();
    function add(v){ const k = norm(v); if(k) seen.add(k); }
    (model && model.parts || []).forEach(add);
    const diagrams = (model && (model._fullDiagrams || model._allDiagrams || model.diagrams)) || [];
    (diagrams || []).forEach(d => {
      (d && d.parts || []).forEach(row => {
        if(Array.isArray(row)) add(row[1]);
        else if(row && typeof row === 'object') add(row.partNumber || row.p || row.mfg_part_no);
      });
    });
    return seen.size || ((model && model.parts || []).length);
  }
  function modelIntro(model, serialAware){
    const brand = model && model.b ? brandLabelFromRoot(model.b) : '';
    const cat = cleanCategoryName(model && model.c);
    const diagrams = diagramsForModel(model);
    return '<section class="yf-match-hero yf-match-hero--model-no-stats"><div><div class="yf-kicker">'+(serialAware?'Serial-aware model match':'Model match')+'</div><h2>'+esc(model.m)+'</h2>'
      + (brand ? '<div class="yf-match-brand">'+esc(brand)+'</div>' : '')
      + '<p>'+esc(cat || '')+'</p></div></section>';
  }
  function partIntro(part, chain, productCount, brandLabel){
    return '<section class="yf-match-hero"><div><div class="yf-kicker">Part number match</div><h2>'+esc(part.p)+'</h2>'
      + (brandLabel ? '<div class="yf-match-brand">'+esc(brandLabel)+'</div>' : '')
      + '<p>'+esc(part.d || '')+'</p></div><div class="yf-match-stats">'
      + stat(part.fits || (part.used||[]).length || 0, 'fits models', 'green')
      + stat(productCount && productCount.__html ? productCount : productCount, 'available products', 'red')
      + '</div></section>';
  }
  function supersessionBanner(partNumber, chain, opts){
    if(!chain) return '';
    opts = opts || {};
    const current = norm(chain.current || partNumber);
    const searched = norm(partNumber);
    const newPart = current || searched;
    const oldSet = new Set();
    const addOld = v => { const k = norm(v); if(k && k !== newPart) oldSet.add(k); };
    if(searched && searched !== newPart) oldSet.add(searched);
    (chain.reverse || []).forEach(addOld);
    if(!oldSet.size && !(chain.forward && chain.forward.length) && !(chain.reverse && chain.reverse.length)) return '';
    const oldNums = Array.from(oldSet);
    const title = opts.title || 'Part Number Information';
    const icon = '<span class="yf-supersession-icon" aria-hidden="true">i</span>';
    return '<div class="yf-supersession-card '+(opts.compact?'compact':'')+'">'
      + '<div class="yf-supersession-title">'+icon+'<strong>'+esc(title)+'</strong></div>'
      + '<div class="yf-supersession-row"><span>New Part Number:</span><b>'+esc(newPart || partNumber)+'</b></div>'
      + (oldNums.length ? '<div class="yf-supersession-row"><span>Old Part Numbers:</span><div class="yf-supersession-pills">'+oldNums.map(n => '<em>'+esc(n)+'</em>').join('')+'</div></div>' : '')
      + '</div>';
  }
  function productConditionLabel(p){
    const t = plain([p && p.title, p && p.vendor, p && p.productType].filter(Boolean).join(' '));
    if(/\bUSED\b/.test(t)) return 'Used';
    if(/\bNEW\b/.test(t)) return 'New';
    return '';
  }
  function productVariantUrl(p){
    const h = p && p.handle;
    if(!h) return (p && p.url) || '#';
    const vid = variantIdFromProduct(p, null);
    return (p.url && String(p.url).includes('/products/')) ? p.url : ('/products/' + h + (vid ? '?variant=' + enc(vid) : ''));
  }
  function skuMetaRow(label, value, copyable){
    const safe = value == null || value === '' ? 'N/A' : value;
    return '<div class="yf-sku-meta-row"><span>'+esc(label)+':</span><strong>'+esc(safe)+'</strong>'+(copyable && safe !== 'N/A' ? '<button class="yf-copy-mini" type="button" data-yf-copy="'+esc(safe)+'" aria-label="Copy '+esc(label)+'">⧉</button>' : '')+'</div>';
  }
  function skuProductHeroCard(p){
    const url = productVariantUrl(p);
    const condition = productConditionLabel(p);
    const stock = p && p.available === false ? 'Out of Stock' : 'In Stock';
    const inventory = p && p.inventory != null && p.inventory !== '' ? (String(p.inventory) + ' units') : (p && p.available === false ? '0 units' : 'Available');
    return '<article class="yf-sku-product-detail">'
      + '<div class="yf-sku-product-head"><div><h3>'+esc((p && p.title) || 'Matching product')+'</h3><div class="yf-sku-badges"><span class="yf-sku-stock '+(stock === 'In Stock' ? 'green' : 'red')+'">'+esc(stock)+'</span>'+(condition ? '<span class="yf-sku-condition">'+esc(condition)+'</span>' : '')+'</div></div>'
      + '<div class="yf-sku-product-img">'+(p && p.imageUrl ? '<img loading="lazy" src="'+esc(p.imageUrl)+'" alt="'+esc(p.title || 'Product image')+'">' : '<span>No image</span>')+'</div></div>'
      + '<div class="yf-sku-price-grid"><div><span>Price:</span><strong class="yf-sku-price">'+esc(money(p && p.price || ''))+'</strong>'+(p && p.compareAtPrice && Number(p.compareAtPrice) > Number(p.price) ? '<small><s>'+esc(money(p.compareAtPrice))+'</s></small>' : '')+'</div><div><span>Inventory:</span><strong>'+esc(inventory)+'</strong></div></div>'
      + '<div class="yf-sku-meta">'
      + skuMetaRow('SKU', p && p.sku, true)
      + skuMetaRow('Part Number', p && p.partNumber, true)
      + skuMetaRow('Model Number', p && (p.modelNumber || p.model || ''), false)
      + skuMetaRow('Location', p && (p.location || 'Alberta - Pickup & Shipping'), false)
      + '</div><a class="yf-btn yf-sku-view-product" href="'+esc(url)+'">View Product ↗</a></article>';
  }
  async function skuBreakdownListFromPart(part){
    const used = (part && part.used || []).slice(0,24);
    const seen = new Set(), items = [];
    for(const u of used){
      const did = u && u[2];
      if(!did || seen.has(did)) continue;
      seen.add(did);
      const d = await db.diagram(did);
      if(d) items.push(d);
      if(items.length >= 8) break;
    }
    return items;
  }
  function skuSidePanel(title, count, body){
    return '<section class="yf-sku-side-panel"><div class="yf-sku-side-head"><strong>'+esc(title)+' ('+esc(count)+')</strong><span>⌃</span></div>'+body+'</section>';
  }
  function skuCompatibleModelsPanel(part){
    const seen = new Set();
    const models = (part && part.used || []).filter(u => { const k = norm(u && u[0]); if(!k || seen.has(k)) return false; seen.add(k); return true; });
    const body = models.length ? '<div class="yf-sku-model-scroll">'+models.slice(0,60).map(u => '<a href="'+nativeSearchUrl(u[0])+'&yf_force=model">'+esc(u[0])+'</a>').join('')+'</div>' : '<div class="yf-sku-empty">No compatible models found.</div>';
    return skuSidePanel('Compatible Models', models.length, body);
  }
  function skuBreakdownsPanel(diagrams){
    diagrams = diagrams || [];
    const body = diagrams.length ? '<div class="yf-sku-list">'+diagrams.map(d => '<a href="'+diagramUrl(d.id)+'"><strong>'+esc(friendlyDiagramTitle(d,null).replace(/ Breakdown Diagram$/,''))+'</strong><span>'+esc([cleanCategoryName(d.c), d.m].filter(Boolean).join(' | '))+'</span></a>').join('')+'</div>' : '<div class="yf-sku-empty">No breakdown diagrams found.</div>';
    return skuSidePanel('Breakdown Diagrams', diagrams.length, body);
  }
  function skuRelatedProductsPanel(products){
    products = products || [];
    const body = products.length ? '<div class="yf-sku-list yf-sku-related">'+products.map(p => '<a href="'+esc(productVariantUrl(p))+'"><strong>'+esc(p.title || 'Related product')+'</strong><span>'+esc(p.partNumber || 'N/A')+'</span><em>'+esc(money(p.price || ''))+'</em></a>').join('')+'</div>' : '<div class="yf-sku-empty">No related products found.</div>';
    return skuSidePanel('Related Products', products.length, body);
  }


  function yfPartInfoCondition(p){
    const explicit = String((p && (p.condition || p.customCondition || p._condition)) || '').trim();
    if(/^used$/i.test(explicit)) return 'Used';
    if(/^new$/i.test(explicit)) return 'New';
    const title = String((p && p.title) || '');
    if(/^\s*used\b/i.test(title) || /\bused\b/i.test(title)) return 'Used';
    return 'New';
  }
  function yfPartInfoSortProducts(items){
    return (items || []).slice().sort((a,b) => {
      const au = yfPartInfoCondition(a) === 'Used' ? 0 : 1;
      const bu = yfPartInfoCondition(b) === 'Used' ? 0 : 1;
      if(au !== bu) return au - bu;
      const ap = Number(String(a.price || '').replace(/[^0-9.]/g,''));
      const bp = Number(String(b.price || '').replace(/[^0-9.]/g,''));
      if(Number.isFinite(ap) && Number.isFinite(bp) && ap !== bp) return ap - bp;
      return String(a.title || '').localeCompare(String(b.title || ''));
    });
  }
  function yfPartInfoNumbers(partNo, chain){
    const seen = new Set();
    const out = [];
    function add(v){ const k = norm(v); if(k && !seen.has(k)){ seen.add(k); out.push(k); } }
    if(chain && chain.current) add(chain.current);
    add(partNo);
    (chain && chain.forward || []).forEach(add);
    (chain && chain.reverse || []).forEach(add);
    return out;
  }
  function yfExtractProductPagePartNumber(root){
    if(!root) return '';
    // Product-page matching must only use the structured extracted part number metafield.
    // Do not fall back to SKU, title, or custom.part_number because those can create false matches.
    return norm(root.dataset.part || '');
  }
  function yfPartInfoHasSupersession(chain){
    return !!(chain && ((chain.forward && chain.forward.length) || (chain.reverse && chain.reverse.length)));
  }
  let yfPartInfoConditionIndexPromise = null;
  function yfPartInfoIndexKey(value){
    return String(value == null ? '' : value).trim().toLowerCase().replace(/[^a-z0-9]+/g, '');
  }
  async function yfPartInfoConditionIndex(){
    const url = window.YF_CONDITION_OPTIONS_INDEX_URL || '';
    if(!url) return {};
    if(!yfPartInfoConditionIndexPromise){
      yfPartInfoConditionIndexPromise = fetch(url, {credentials:'same-origin'})
        .then(r => r && r.ok ? r.json() : {})
        .then(data => data && (data.parts || data) || {})
        .catch(() => ({}));
    }
    return yfPartInfoConditionIndexPromise;
  }
  async function yfProductsFromConditionIndex(partNumbers, excludeHandle){
    const idx = await yfPartInfoConditionIndex();
    const out = [];
    const seen = new Set();
    (partNumbers || []).forEach(pn => {
      const rows = idx[yfPartInfoIndexKey(pn)] || [];
      rows.forEach(raw => {
        const h = raw && (raw.handle || (raw.url && String(raw.url).split('/products/')[1] || '').split(/[?#]/)[0]);
        if(!h || h === excludeHandle || seen.has(h)) return;
        seen.add(h);
        out.push({
          handle: h,
          url: raw.url || ('/products/' + h),
          title: raw.title || '',
          imageUrl: raw.image || raw.featured_image || '',
          price: raw.price || '',
          compareAtPrice: raw.compareAtPrice || raw.compare_at_price || '',
          partNumber: raw.partNumber || pn,
          available: raw.available !== false,
          inventory: raw.inventory,
          _matchedPart: pn,
          _condition: yfPartInfoCondition(raw)
        });
      });
    });
    return out;
  }
  async function yfProductsForExactPartNumbers(partNumbers, excludeHandle){
    const out = [];
    const seen = new Set();
    function pushProduct(p, pn){
      const h = p && p.handle;
      if(!h || h === excludeHandle || seen.has(h)) return;
      seen.add(h);
      out.push(Object.assign({}, p, {
        imageUrl: p.imageUrl || p.image || p.featured_image || '',
        _matchedPart: pn || p._matchedPart || p.partNumber || '',
        _condition: yfPartInfoCondition(p)
      }));
    }
    for(const pn of (partNumbers || [])){
      const rec = await db.productPart(pn);
      (rec && rec.products || []).forEach(p => pushProduct(p, pn));
    }

    // Product pages must match from yf_extracted_data.part_number only, but the product-part
    // database does not always contain every duplicate Shopify product. Add the same exact
    // part-number condition index used by collection cards so New products still show
    // Other Matching Parts when the only available matches are other New products.
    const conditionIndexProducts = await yfProductsFromConditionIndex(partNumbers, excludeHandle);
    conditionIndexProducts.forEach(p => pushProduct(p, p._matchedPart));

    const live = await filterLiveOnlineInStockProducts(out, 64);
    return yfPartInfoSortProducts(live.map(p => Object.assign({}, p, {
      imageUrl: p.imageUrl || p.image || p.featured_image || '',
      _condition: yfPartInfoCondition(p)
    })));
  }
  function yfPartInfoProductCard(p){
    const url = productVariantUrl(p);
    const condition = yfPartInfoCondition(p);
    return '<a class="yf-part-info-match-card" href="'+esc(url)+'">'
      + '<div class="yf-part-info-match-img">'+(p.imageUrl ? '<img loading="lazy" src="'+esc(p.imageUrl)+'" alt="'+esc(p.title || 'Matching part')+'">' : '<span>No image</span>')+'</div>'
      + '<div class="yf-part-info-match-copy"><span class="yf-part-info-condition '+(condition === 'Used' ? 'used' : 'new')+'">'+esc(condition)+'</span>'
      + '<strong>'+esc(p.title || 'Matching product')+'</strong>'
      + '<div class="yf-part-info-match-meta">'+(p.partNumber ? '<span>Part '+esc(p.partNumber)+'</span>' : '')+(p._matchedPart ? '<span>Matched '+esc(p._matchedPart)+'</span>' : '')+'</div>'
      + '<div class="yf-part-info-match-price">'+esc(money(p.price || ''))+(p.compareAtPrice && Number(p.compareAtPrice) > Number(p.price) ? ' <s>'+esc(money(p.compareAtPrice))+'</s>' : '')+'</div>'
      + '</div></a>';
  }
  async function initProductPartInfoWidgets(){
    document.querySelectorAll('[data-yf-product-part-info]').forEach(async root => {
      if(root.dataset.bound) return;
      root.dataset.bound = '1';
      const partNo = yfExtractProductPagePartNumber(root);
      const exclude = root.dataset.handle || '';
      if(!partNo){ root.hidden = true; root.innerHTML = ''; return; }
      try{
        const chain = await supersessionChain(partNo);
        const nums = yfPartInfoNumbers(partNo, chain);
        const products = await yfProductsForExactPartNumbers(nums, exclude);
        const currentCondition = yfPartInfoCondition({condition: root.dataset.condition || ''});
        const usedProducts = products.filter(p => yfPartInfoCondition(p) === 'Used');
        const displayProducts = (currentCondition === 'New' && usedProducts.length) ? usedProducts : products;
        const hasSupersessionInfo = yfPartInfoHasSupersession(chain);
        const banner = hasSupersessionInfo ? supersessionBanner(partNo, chain, {title:'Part Number Information', compact:true}) : '';

        // Product-page matching must only use yf_extracted_data.part_number, but it should
        // still show for New products when active, online, in-stock Used options exist for
        // the same exact extracted part number. Do not require old/superseded numbers for
        // that used-options drawer.
        if(!hasSupersessionInfo && !displayProducts.length){ root.hidden = true; root.innerHTML = ''; return; }

        root.hidden = false;
        const count = displayProducts.length;
        const isUsedOptions = currentCondition === 'New' && usedProducts.length > 0;
        const autoOpenUsedOptions = isUsedOptions && usedProducts.length <= 2;
        const buttonText = isUsedOptions ? 'Show Used Options' : 'Other Matching Parts';
        const panelTitle = autoOpenUsedOptions ? 'Used Options' : (isUsedOptions ? (count + ' used option' + (count === 1 ? '' : 's')) : (count + ' matching part' + (count === 1 ? '' : 's')));
        let html = '<div class="yf-part-info-widget '+(isUsedOptions ? 'is-used-options' : '')+(autoOpenUsedOptions ? ' is-auto-open-used-options' : '')+'">' + (banner || '');
        if(displayProducts.length){
          if(autoOpenUsedOptions){
            html += '<div class="yf-part-info-auto-title"><span>'+esc(panelTitle)+'</span><em>'+esc(count)+' available</em></div>'
              + '<div class="yf-part-info-matches" data-yf-part-info-matches><div class="yf-part-info-match-grid">'+displayProducts.map(yfPartInfoProductCard).join('')+'</div></div>';
          }else{
            html += '<button type="button" class="yf-part-info-toggle" data-yf-part-info-toggle aria-expanded="false"><span>'+esc(buttonText)+'</span><em>'+esc(count)+' available</em></button>'
              + '<div class="yf-part-info-matches" data-yf-part-info-matches hidden><div class="yf-part-info-match-head"><strong>'+esc(panelTitle)+'</strong></div><div class="yf-part-info-match-grid">'+displayProducts.map(yfPartInfoProductCard).join('')+'</div></div>';
          }
        }
        html += '</div>';
        root.innerHTML = html;
        root.classList.toggle('is-open', !!autoOpenUsedOptions);
        const btn = root.querySelector('[data-yf-part-info-toggle]');
        const panel = root.querySelector('[data-yf-part-info-matches]');
        if(btn && panel){
          btn.addEventListener('click', function(e){
            e.preventDefault();
            e.stopPropagation();
            const open = panel.hidden;
            panel.hidden = !open;
            btn.setAttribute('aria-expanded', open ? 'true' : 'false');
            root.classList.toggle('is-open', open);
          });
        }
      }catch(e){
        console.warn('YF product part info failed', e);
        root.hidden = true; root.innerHTML = '';
      }
    });
  }
  async function renderSkuLookup(root, q, matches){
    const res = root.querySelector('[data-yf-results]');
    const enriched = await mapLimit((matches || []).slice(0,4), 4, enrichSkuProduct);
    const first = enriched[0];
    if(!first){ return false; }
    const part = first.partNumber ? await db.part(first.partNumber) : null;
    const [diagrams, related] = await Promise.all([skuBreakdownListFromPart(part), relatedProductsForSkuProduct(first, part, 6)]);
    const intro = '<section class="yf-sku-lookup"><div class="yf-sku-exact-line"><span class="yf-tech-badge">ⓘ Technical Specs</span><span>Exact Match: <strong>'+esc(first.sku || q)+'</strong></span></div><div class="yf-sku-layout">'
      + '<div class="yf-sku-main">'+enriched.map(skuProductHeroCard).join('')+'</div>'
      + '<aside class="yf-sku-sidebar">'+skuCompatibleModelsPanel(part)+skuBreakdownsPanel(diagrams)+skuRelatedProductsPanel(related)+'</aside></div></section>';
    res.innerHTML = intro;
    bindSkuCopyButtons(res);
    scheduleNativePageCacheSave(res, true);
    return true;
  }
  function bindSkuCopyButtons(scope){
    (scope || document).querySelectorAll('[data-yf-copy]').forEach(btn => {
      if(btn.dataset.copyBound) return;
      btn.dataset.copyBound = '1';
      btn.addEventListener('click', async e => {
        e.preventDefault(); e.stopPropagation();
        const txt = btn.getAttribute('data-yf-copy') || '';
        try{ await navigator.clipboard.writeText(txt); btn.textContent = '✓'; setTimeout(()=>{ btn.textContent = '⧉'; }, 900); }catch(err){}
      });
    });
  }

  function productScroller(title, text, products, empty){
    const showCondition = /Available replacement parts|Available products from this diagram/i.test(String(title || ''));
    return '<section class="yf-panel yf-products-panel"><div class="yf-panel-head"><div><h2>'+esc(title)+'</h2>'+((text&&String(text).trim())?'<p>'+esc(text)+'</p>':'')+'</div><strong>'+esc(products.length)+'</strong></div>'
      + (products.length ? '<div class="yf-product-rail">'+products.map(p => productCard(p, {matchedPart:p._matchedPart || p.partNumber, badge:p._label, badgeClass:p._klass, showCondition:showCondition})).join('')+'</div>' : '<div class="yf-empty-state">'+esc(empty || 'No active in-stock Shopify products found.')+'</div>') + '</section>';
  }

  function productPlaceholder(id, title, text){
    return '<section id="'+esc(id)+'" class="yf-panel yf-products-panel yf-products-loading"><div class="yf-panel-head"><div><h2>'+esc(title)+'</h2>'+((text&&String(text).trim())?'<p>'+esc(text)+'</p>':'')+'</div><strong>…</strong></div><div class="yf-loading soft"><span></span> Checking live Shopify products…</div></section>';
  }
  function replaceProductPanel(scope, id, title, text, products, empty){
    const el = scope.querySelector('#' + id);
    if(!el) return;
    el.outerHTML = productScroller(title, text, products || [], empty);
    scheduleNativePageCacheSave(scope, false);
    idle(function(){ hydrateProducts(scope).then(function(){ scheduleNativePageCacheSave(scope, false); }).catch(function(){ scheduleNativePageCacheSave(scope, false); }); });
  }
  async function lazyLoadModelProducts(scope, model, q, opts){
    opts = opts || {};
    const currentHandle = String(opts.currentHandle || '').trim();
    const completePanelId = opts.completePanelId || 'yf-complete-products';
    const modelPanelId = opts.modelPanelId || 'yf-model-products';
    const markCurrentProduct = (products) => (products || []).map(function(p){
      const h = String((p && p.handle) || '').trim();
      if(currentHandle && h && h === currentHandle){
        return Object.assign({}, p, {_label:'Current product', _klass:'current'});
      }
      return p;
    });
    const completeTask = (async () => {
      try{
        const completeUnits = markCurrentProduct(await productsForCompleteUnit(model, q, 12));
        replaceProductPanel(scope, completePanelId, 'Complete units', '', completeUnits, 'No complete units are currently active, online, and in stock for this model number.');
      }catch(e){ replaceProductPanel(scope, completePanelId, 'Complete units', '', [], 'Could not check complete units.'); }
    })();
    const partsTask = (async () => {
      try{
        const modelProducts = await productsForModel(model, 48);
        replaceProductPanel(scope, modelPanelId, 'Available replacement parts for this model', '', modelProducts, 'No active in-stock replacement products matched any breakdown part number for this model yet.');
      }catch(e){ replaceProductPanel(scope, modelPanelId, 'Available replacement parts for this model', '', [], 'Could not check replacement parts.'); }
    })();
    await Promise.allSettled([completeTask, partsTask]);
  }
  async function lazyLoadPartProducts(scope, part){
    try{
      const partCtx = await inferBrandsForPartNumber(part.p, part);
      const chainRes = await productsForChain(part.p, partCtx);
      const products = chainRes.items.map(i => Object.assign({}, i.product, {_matchedPart:i.matchedPart,_label:i.label,_klass:i.klass}));
      const stats = scope.querySelector('[data-yf-part-product-count]'); if(stats) stats.textContent = products.length;
      replaceProductPanel(scope, 'yf-part-products', 'Available products for this part', 'Shows available Shopify products for the searched number, newer replacements, and older related numbers.', products, 'No active in-stock Shopify product matched this part number or its replacement chain yet.');
    }catch(e){ replaceProductPanel(scope, 'yf-part-products', 'Available products for this part', 'Shows available Shopify products for the searched number, newer replacements, and older related numbers.', [], 'Could not check products.'); }
  }
  async function lazyLoadBreakdownProducts(scope, m, modelQ, parts, serialQ){
    const completeTask = (async () => {
      try{
        const completeUnits = await productsForCompleteUnit(m, modelQ, 12);
        replaceProductPanel(scope, 'yf-breakdown-complete-products', 'Complete units', '', completeUnits, 'No complete units available.');
      }catch(e){ replaceProductPanel(scope, 'yf-breakdown-complete-products', 'Complete units', '', [], 'Could not check complete units.'); }
    })();
    const partsTask = (async () => {
      try{
        const products = await productsForPartsDirect(parts, 72, {expectedBrands:[m && m.b].filter(Boolean), expectedCategory:m && m.c, fastStatic:true, requireOnlineStore:true});
        replaceProductPanel(scope, 'yf-breakdown-part-products', serialQ?'Available replacement parts for this serial':'Available replacement parts for this model', '', products, 'No active in-stock products matched these diagram part numbers yet.');
      }catch(e){ replaceProductPanel(scope, 'yf-breakdown-part-products', serialQ?'Available replacement parts for this serial':'Available replacement parts for this model', '', [], 'Could not check replacement products.'); }
    })();
    await Promise.allSettled([completeTask, partsTask]);
  }
  function breakdownPreview(model, serial){
    let diagrams = diagramsForModel(model, serial);
    if(modelHasSerialHierarchy(model) && !serial) return '';
    return '<section class="yf-panel"><div class="yf-panel-head"><div><h2>All matching breakdowns</h2><p>Open a breakdown to view reference numbers and matching Shopify products.</p></div><strong>'+esc(diagrams.length)+'</strong></div>'+diagramGrid(diagrams, model, 'No breakdown diagrams found.')+'</section>';
  }

  async function renderSearch(root, q, opts){
    opts = opts || {};
    const res = root.querySelector('[data-yf-results]');
    if(!q){
      if(opts.removeWhenNoModel){ if(root && root.remove) root.remove(); return; }
      res.innerHTML = '<section class="yf-welcome"><h2>Find the right RV part faster</h2><p>Search a model number, part number, or category. Try <strong>G6A-7</strong>, <strong>RM2652</strong>, <strong>91602</strong>, or <strong>water heater</strong>.</p></section>'; return;
    }
    res.innerHTML = '<div class="yf-loading"><span></span> Finding the best match for '+esc(q)+'…</div>';
    try{
      const forceMatch = opts.modelOnly ? 'model' : ((new URLSearchParams(location.search).get('yf_force') || '').toLowerCase());
      const skuMatches = (forceMatch === 'model' || forceMatch === 'part') ? [] : await db.sku(q);
      if(skuMatches && skuMatches.length){ await renderSkuLookup(root, q, skuMatches); return; }
      if(forceMatch === 'sku'){ res.innerHTML = ''; return; }
      let part = forceMatch === 'model' ? null : await bestPartForQuery(q);
      let model = forceMatch === 'part' ? null : await bestModelForQuery(q);
      const preferPart = shouldPreferPartMatch(q, part, model, forceMatch);
      if(preferPart) model = null;
      else if(model) part = null;
      if(model){
        model._allDiagrams = await allDiagramSummariesForModel(model);
        try{
          const fullForModel = await fullDiagramsFromSummaries(model._allDiagrams);
          if(fullForModel && fullForModel.length){
            model._fullDiagrams = fullForModel;
            model._allDiagrams = fullForModel;
          }
        }catch(e){ console.warn('Could not load full model diagrams for count/preview', e); }
      }
      if(opts.modelOnly && !model){
        if(opts.removeWhenNoModel){ if(root && root.remove) root.remove(); }
        else res.innerHTML = '';
        return;
      }
      let collection = await primaryCollection(q, model, part);
      // V38: keep the search-results panel in sync with the header dropdown.
      // If there is no exact model/part database match, still show the same curated/referring-link
      // collection matches that appear while typing (ex: tire, ladder, water pups).
      let curatedCollections = [];
      if(!model && !part){
        curatedCollections = await collectionsForQuery(q, null, null, collection);
        if(!collection && curatedCollections && curatedCollections.length) collection = curatedCollections[0];
      }
      let html = '<div class="yf-layout">';
      let main = '', side = '';

      if(model){
        const serialAware = modelHasSerialHierarchy(model);
        main += modelIntro(model, serialAware);
        if(serialAware){
          main += serialPickerHtml(model);
          main += '<section class="yf-panel yf-soft"><h2>Choose a serial before we show parts</h2><p>This model has serial-specific breakdowns. We hide complete units, replacement parts, and diagram choices until a serial is selected so customers do not buy parts from the wrong production run.</p></section>';
          if(collection) main += suggestedCollectionsPanel([collection], 'Recommended collection', '');
        }else{
          main += breakdownPreview(model);
          main += productPlaceholder('yf-complete-products', 'Complete units', '');
          if(collection) main += suggestedCollectionsPanel([collection], 'Recommended collection', '');
          main += productPlaceholder('yf-model-products', 'Available replacement parts for this model', '');
        }
      } else if(part){
        const chain = await supersessionChain(part.p);
        const partCtx = await inferBrandsForPartNumber(part.p, part);
        const pBrand = partBrandLabel(part, partCtx);
        main += partIntro(part, chain, {__html:'<span data-yf-part-product-count>…</span>'}, pBrand);
        main += supersessionBanner(part.p, chain);
        main += productPlaceholder('yf-part-products', 'Available products for this part', 'Shows available Shopify products for the searched number, newer replacements, and older related numbers.');
        if(collection) main += suggestedCollectionsPanel([collection], 'Recommended collection', '');
        main += '<section class="yf-panel"><div class="yf-panel-head"><div><h2>Fits these models</h2><p>Open a model to view the breakdown and related parts.</p></div><strong>'+esc((part.used||[]).length)+'</strong></div><div class="yf-model-list">'+(part.used||[]).slice(0,80).map(u => '<a href="'+nativeSearchUrl(u[0])+'"><strong>'+esc(u[0])+'</strong></a>').join('')+'</div></section>';
      } else if(collection || (curatedCollections && curatedCollections.length)){
        const collections = (curatedCollections && curatedCollections.length) ? curatedCollections : await collectionsForQuery(q, null, null, collection);
        const rule = referringRuleForQuery(q);
        const catInfo = await categoryInfoForSearch(q, collections);
        // V38: category-only searches should show useful collection matches, not a "no database match" card.
        main += categorySearchIntro(q, rule, collections);
        main += categoryCollectionsPanel(collections);
        if(catInfo){
          main += categorySelectorShell(catInfo, q);
        }
      } else {
        // V38: if nothing smart matches, render nothing above Shopify's native search results.
        main += '';
      }

      html += '<div class="yf-main-col '+(!side ? 'wide' : '')+'">'+main+'</div>'+(side ? '<aside class="yf-side-col">'+side+'</aside>' : '')+'</div>';
      res.innerHTML = html;
      hydrateProducts(res).then(function(){ scheduleNativePageCacheSave(res, false); }).catch(function(){ scheduleNativePageCacheSave(res, false); });
      hydrateCollectionCards(res).then(function(){ scheduleNativePageCacheSave(res, false); }).catch(function(){ scheduleNativePageCacheSave(res, false); });
      initCollectionLinkSafety(res); initSerialSelectors(res); initCategoryWidgets(); bindDiagramInteractions(res);
      if(model && !modelHasSerialHierarchy(model)) lazyLoadModelProducts(res, model, q);
      if(part) lazyLoadPartProducts(res, part);
    }catch(e){ console.error(e); res.innerHTML = '<div class="yf-empty-state">Something went wrong loading the native parts data. Please try again.</div>'; }
  }

  async function renderPart(root, q){
    const res = root.querySelector('[data-yf-results]'); q = q || '';
    if(!q){ res.innerHTML = '<div class="yf-empty-state">Enter a part number.</div>'; return; }
    const part = await db.part(q);
    if(!part){ res.innerHTML = '<div class="yf-empty-state">Part number not found.</div>'; return; }
    const chainRes = await productsForChain(part.p, await inferBrandsForPartNumber(part.p, part));
    const products = chainRes.items.map(i => Object.assign({}, i.product, {_matchedPart:i.matchedPart,_label:i.label,_klass:i.klass}));
    res.innerHTML = '<div class="yf-main-col wide">'+partIntro(part, chainRes.chain, products.length)+supersessionBanner(part.p, chainRes.chain)+productScroller('Available products', 'Live Shopify products matched by yf_extracted_data.part_number.', products, 'No active products found.')+'<section class="yf-panel"><h2>Compatible models</h2><div class="yf-model-list">'+(part.used||[]).slice(0,160).map(u=>'<a href="'+nativeSearchUrl(u[0])+'"><strong>'+esc(u[0])+'</strong></a>').join('')+'</div></section></div>';
    hydrateProducts(res).then(function(){ scheduleNativePageCacheSave(res, false); }).catch(function(){ scheduleNativePageCacheSave(res, false); });
  }

  async function renderBreakdown(root, params){
    const res = root.querySelector('[data-yf-results]');
    const diagramId = params.get('diagram'); const modelQ = params.get('model') || params.get('q'); const serialQ = String(params.get('serial') || '').trim();
    res.innerHTML = '<div class="yf-loading"><span></span> Loading breakdown…</div>';
    if(diagramId){ const d = await db.diagram(diagramId); if(!d){ res.innerHTML = '<div class="yf-empty-state">Diagram not found.</div>'; return; } return renderDiagram(root, d); }
    if(modelQ){
      const m = await bestModelForQuery(modelQ); if(!m){ res.innerHTML = '<div class="yf-empty-state">No breakdowns found for this model.</div>'; return; }
      m._allDiagrams = await allDiagramSummariesForModel(m);
      if(modelHasSerialHierarchy(m) && !serialQ){ res.innerHTML = modelIntro(m, true) + serialPickerHtml(m); initSerialSelectors(res); scheduleNativePageCacheSave(res, false); return; }
      let diagramSummaries = await allDiagramSummariesForModel(m, serialQ || '');
      const diagrams = displayDiagrams(await fullDiagramsFromSummaries(diagramSummaries));
      let parts = partNumbersFromDiagrams(diagrams); if(!parts.length && !serialQ) parts = (m.parts || []);
      const col = await primaryCollection(modelQ, m, null);
      const serialTitle = serialQ ? 'Serial '+esc(serialQ)+' breakdowns' : 'Breakdown diagrams';
      const serialCopy = serialQ ? 'These diagrams and products are filtered to the selected serial number only.' : 'Use the diagram to confirm reference numbers before buying.';
      res.innerHTML = '<div class="yf-layout"><div class="yf-main-col">'+modelIntro(m, false)+'<section class="yf-panel"><div class="yf-panel-head"><div><h2>'+serialTitle+'</h2><p>'+serialCopy+'</p></div><strong>'+esc(diagrams.length)+'</strong></div>'+diagramGrid(diagrams, m, serialQ ? 'No diagrams found for this serial.' : 'No diagrams found for this model.')+'</section>'+productPlaceholder('yf-breakdown-complete-products', 'Complete units', '')+productPlaceholder('yf-breakdown-part-products', serialQ?'Available replacement parts for this serial':'Available replacement parts for this model', '')+'</div><aside class="yf-side-col">'+(col?'<section class="yf-panel side">'+collectionCard(col)+'</section>':'')+'<section class="yf-panel side"><h2>Need a different serial?</h2><a class="yf-btn ghost" href="'+modelBreakdownUrl(m.m)+'">Change serial/model</a></section></aside></div>';
      hydrateProducts(res).then(function(){ scheduleNativePageCacheSave(res, false); }).catch(function(){ scheduleNativePageCacheSave(res, false); });
      hydrateCollectionCards(res).then(function(){ scheduleNativePageCacheSave(res, false); }).catch(function(){ scheduleNativePageCacheSave(res, false); });
      initCollectionLinkSafety(res); bindDiagramInteractions(res); lazyLoadBreakdownProducts(res, m, modelQ, parts, serialQ); return;
    }
    res.innerHTML = '<div class="yf-welcome"><h2>Find a breakdown diagram</h2><p>Search a model number above to see diagrams and matching parts.</p></div>';
    scheduleNativePageCacheSave(res, false);
  }

  async function productsForReferencePart(pn, chain){
    const nums = [];
    const add = v => { const k = norm(v); if(k && !nums.includes(k)) nums.push(k); };
    add(pn);
    if(chain && chain.forward && chain.forward.length) chain.forward.forEach(add);
    if(chain && chain.current) add(chain.current);
    if(chain && chain.reverse && chain.reverse.length) chain.reverse.forEach(add);
    const out = [];
    const seen = new Set();
    await Promise.all(nums.slice(0,8).map(async num => {
      const label = norm(num) === norm(pn) ? 'Exact part' : (chain && chain.forward && chain.forward.map(norm).includes(norm(num))) || (chain && norm(chain.current) === norm(num) && norm(num)!==norm(pn)) ? 'Replacement' : 'Related number';
      const klass = label === 'Replacement' ? 'blue' : (label === 'Related number' ? 'amber' : 'green');
      const ps = await productsForPart(num, {fastStatic:true});
      ps.slice(0,4).forEach(pr => {
        const h = pr && pr.handle;
        if(!h || seen.has(h)) return;
        seen.add(h);
        out.push(Object.assign({}, pr, {_matchedPart:num, _label:label, _klass:klass}));
      });
    }));
    // Breakdown diagram product rows and the "Available products from this diagram" panel
    // must only use products that Shopify confirms are available on the Online Store and in stock.
    // The fast static index is still used for speed, but every visible product is verified live here.
    return filterLiveOnlineInStockProducts(out, 8);
  }


  function refRank(ref){
    const raw = String(ref == null ? '' : ref).trim();
    if(!raw || /^NS$/i.test(raw)) return [999999, raw];
    const m = raw.match(/^(\d+)([A-Za-z]*)/);
    if(m) return [parseInt(m[1],10), (m[2]||'')];
    return [500000, raw];
  }
  function sortDiagramParts(parts){
    return (parts || []).slice().sort((a,b) => {
      const ar = refRank(a && a[0]);
      const br = refRank(b && b[0]);
      if(ar[0] !== br[0]) return ar[0] - br[0];
      if(ar[1] !== br[1]) return String(ar[1]).localeCompare(String(br[1]));
      return String((a && a[1]) || '').localeCompare(String((b && b[1]) || ''));
    });
  }
  async function enrichDiagramParts(d, relatedModel){
    // Build the visible parts list from every source that can belong to this
    // displayed diagram. Many old breakdown imports split one breakdown across
    // two records: a real scanned diagram image, and a DinoLogo/placeholder row
    // that contains the complete reference/parts table. If we only use d.parts,
    // the customer sees the diagram image but the right-side reference list is
    // missing most callouts. So for a real image diagram, merge any placeholder
    // sibling parts for the exact same model/serial/category before enriching.
    const base = (d && Array.isArray(d.parts)) ? d.parts.slice() : [];
    const seen = new Set();
    function addRow(row){
      if(!row) return;
      const ref = (row[0] == null || row[0] === '') ? 'NS' : row[0];
      const pn = row[1] || '';
      const key = norm(ref) + '|' + norm(pn);
      if(seen.has(key)) return;
      seen.add(key);
      base.push([ref, pn, row[2] || '', row[3] == null ? null : row[3], row[4] == null ? null : row[4]]);
    }
    // Reset base via addRow so duplicate checks are normalized.
    const original = base.splice(0, base.length);
    original.forEach(addRow);

    try{
      if(relatedModel && relatedModel._allDiagrams && !isPlaceholderDiagram(d)){
        const siblings = await fullDiagramsFromSummaries(relatedModel._allDiagrams || []);
        const currentSerial = (d && d.s) || '';
        (siblings || []).forEach(sib => {
          if(!sib || !sib.parts || !sib.parts.length) return;
          if(!isPlaceholderDiagram(sib)) return;
          if(norm(sib.m) !== norm(d && d.m)) return;
          if(norm((sib.s || '')) !== norm((currentSerial || ''))) return;
          (sib.parts || []).forEach(addRow);
        });
      }
    }catch(e){ console.warn('Could not merge sibling breakdown reference table', e); }

    // Some diagram records can also be missing legacy/replaced rows even though
    // part_knowledge.used points back to this same diagram id. Add those too.
    const candidates = new Set();
    base.forEach(x => { if(x && x[1]) candidates.add(String(x[1])); });
    ((relatedModel && relatedModel.parts) || []).forEach(pn => { if(pn) candidates.add(String(pn)); });
    const diagramIds = new Set([String((d && d.id) || '')]);
    // If this is a real image backed by placeholder table rows, also allow the
    // placeholder diagram id when checking part_knowledge.used.
    try{
      if(relatedModel && relatedModel._allDiagrams && !isPlaceholderDiagram(d)){
        const siblings = await fullDiagramsFromSummaries(relatedModel._allDiagrams || []);
        const currentSerial = (d && d.s) || '';
        (siblings || []).forEach(sib => {
          if(!sib || !isPlaceholderDiagram(sib)) return;
          if(norm(sib.m) !== norm(d && d.m)) return;
          if(norm((sib.s || '')) !== norm((currentSerial || ''))) return;
          if(sib.id) diagramIds.add(String(sib.id));
        });
      }
    }catch(e){}
    await mapLimit(Array.from(candidates).slice(0,700), 14, async pn => {
      const rec = await db.part(pn);
      if(!rec || !Array.isArray(rec.used)) return;
      rec.used.forEach(u => {
        const did = String((u && u[2]) || '');
        if(!diagramIds.has(did)) return;
        const ref = (u && u[1]) || 'NS';
        const partNo = rec.p || rec.n || pn;
        addRow([ref, partNo, rec.d || '', null, null]);
      });
    });
    return sortDiagramParts(base);
  }

  function bindReferenceSearch(scope){
    const input = scope.querySelector('[data-yf-ref-search]');
    if(!input || input.dataset.bound) return;
    input.dataset.bound = '1';
    input.addEventListener('input', () => {
      const q = norm(input.value);
      scope.querySelectorAll('.yf-part-row').forEach(row => {
        // Reference search on breakdown pages should only filter by the diagram reference number.
        // It should not match part numbers, descriptions, supersessions, or product text.
        const refOnly = norm(row.getAttribute('data-ref-number') || '');
        row.hidden = !!q && !refOnly.includes(q);
      });
    });
  }
  function bindDiagramInteractions(scope){
    bindReferenceSearch(scope);
    scope.querySelectorAll('.yf-callout-dot').forEach(btn => {
      if(btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', () => {
        const i = btn.dataset.i;
        scope.querySelectorAll('.yf-callout-dot').forEach(b => b.classList.toggle('active', b === btn));
        scope.querySelectorAll('.yf-part-row').forEach(r => r.classList.toggle('active', r.getAttribute('data-part-i') === i));
        const row = scope.querySelector('[data-part-i="'+i+'"]');
        if(row) row.scrollIntoView({behavior:'smooth', block:'center'});
      });
    });
  }

  async function renderDiagram(root, d){
    const res = root.querySelector('[data-yf-results]');
    const relatedModel = d && d.m ? await db.model(d.m) : null;
    if(relatedModel){ relatedModel._allDiagrams = await allDiagramSummariesForModel(relatedModel); }
    const relatedAll = displayDiagrams(relatedModel && relatedModel._allDiagrams ? relatedModel._allDiagrams : []);
    // On an individual serial/product-id breakdown page, only show sibling
    // breakdowns for that exact serial number. Previously this panel used every
    // breakdown in the model series, which mixed unrelated serial ranges.
    const currentDiagramSerial = norm((d && d.s) || '');
    const related = currentDiagramSerial
      ? relatedAll.filter(x => norm((x && x.s) || '') === currentDiagramSerial)
      : relatedAll;
    const parts = await enrichDiagramParts(d, relatedModel);
    const uniq = [...new Set(parts.map(x => x[1]).filter(Boolean))];
    const productMap = {}, productListMap = {}, chainMap = {};
    await mapLimit(uniq.slice(0,260), 18, async pn => {
      const chain = await supersessionChain(pn);
      const list = await productsForReferencePart(pn, chain);
      productListMap[pn] = list;
      productMap[pn] = list[0] || null;
      chainMap[pn] = chain;
    });
    const seenAvailable = new Set();
    const available = [];
    Object.keys(productListMap).forEach(pn => (productListMap[pn] || []).forEach(pr => { if(pr && pr.handle && !seenAvailable.has(pr.handle)){ seenAvailable.add(pr.handle); available.push(pr); } }));
    const dots = parts.filter(x => x[3] != null && x[4] != null).map((x,i) => '<button class="yf-callout-dot" style="left:'+esc(x[3])+'%;top:'+esc(x[4])+'%" data-i="'+i+'">'+esc(x[0])+'</button>').join('');
    const rows = parts.map((x,i) => {
      const ref = x[0] || 'NS';
      const pn = x[1] || '';
      const chain = chainMap[pn] || {};
      const sup = supersessionBanner(pn, chain, {compact:true});
      const plist = productListMap[pn] || [];
      const products = plist.length ? '<div class="yf-ref-products">'+plist.slice(0,4).map(pr => {
        const url = pr.url || ('/products/' + (pr.handle || ''));
        return '<a class="yf-part-product" data-yf-product-card data-handle="'+esc(pr.handle||'')+'" href="'+esc(url)+'">'
          + '<div class="yf-part-product-img" data-yf-product-img>'+(pr.imageUrl?'<img loading="lazy" src="'+esc(pr.imageUrl)+'" alt="">':'')+'</div>'
          + '<div class="yf-part-product-copy"><span class="yf-product-badge '+esc(pr._klass||'')+'">'+esc(pr._label||'Product')+'</span><strong>'+esc(pr.title||'Matching product')+'</strong><div class="yf-part-product-price" data-yf-product-price>'+esc(money(pr.price||''))+'</div><span data-yf-product-availability class="yf-stock small">In stock</span></div></a>';
      }).join('')+'</div>' : '<div class="yf-oos-note">Out of stock</div>';
      const btn = plist.length ? '<a class="yf-btn small" href="'+esc(plist[0].url||('/products/'+plist[0].handle))+'">View</a>' : '<span class="yf-oos small">Out of stock</span>';
      return '<div class="yf-part-row" data-part-i="'+i+'" data-ref-number="'+esc(ref)+'"><div class="yf-ref">'+esc(ref)+'</div><div class="yf-part-main"><strong>'+esc(pn || 'No part #')+'</strong><span>'+esc(x[2] || '')+'</span>'+sup+products+'</div>'+btn+'</div>';
    }).join('');
    const relatedTitle = currentDiagramSerial ? 'All breakdowns for this serial' : 'All breakdowns for this model';
    const relatedSubtext = currentDiagramSerial
      ? 'Switch between breakdowns connected to serial '+((d && d.s) ? esc(d.s) : 'this serial')+'.'
      : 'Switch between every individual breakdown connected to '+esc((relatedModel && relatedModel.m) || d.m || 'this model')+'.';
    const relatedPanel = related && related.length > 1 ? '<section class="yf-panel"><div class="yf-panel-head"><div><h2>'+relatedTitle+'</h2><p>'+relatedSubtext+'</p></div><strong>'+esc(related.length)+'</strong></div>'+diagramGrid(related, relatedModel || d, '', d.id)+'</section>' : '';
    const html = '<section class="yf-panel yf-diagram-page"><div class="yf-diagram-titlebar"><div><div class="yf-kicker">Breakdown diagram</div><h2>'+esc(friendlyDiagramTitle(d,null))+'</h2><p>'+esc(diagramSubtext(d))+'</p></div><a class="yf-btn ghost" href="'+nativeSearchUrl(d.m)+'">Search model</a></div><div class="yf-diagram-workspace"><div class="yf-diagram-left"><div class="yf-diagram-wrap"><img class="yf-diagram-img" src="'+esc(d.url)+'" alt="'+esc([d.b,d.m].filter(Boolean).join(' '))+' breakdown" loading="eager">'+dots+'</div></div><aside class="yf-parts-panel"><div class="yf-parts-panel-head"><div><strong>Parts list</strong><span>'+esc(parts.length)+' refs</span></div><input class="yf-ref-search" data-yf-ref-search type="search" inputmode="search" placeholder="Search reference or part #"></div><div class="yf-parts-list">'+rows+'</div></aside></div></section>' + relatedPanel + (available.length ? productScroller('Available products from this diagram', 'Live Shopify products connected to diagram part numbers.', available.slice(0,32), '') : '');
    res.innerHTML = html;
    hydrateProducts(res).then(function(){ scheduleNativePageCacheSave(res, false); }).catch(function(){ scheduleNativePageCacheSave(res, false); });
    bindDiagramInteractions(res);
  }

  function ddItem(type,title,desc,href){
    let extra = '';
    let finalHref = href || nativeSearchUrl(title || '');
    if(type === 'collection'){
      const h = canonicalCollectionHandle(finalHref || title || desc);
      // V49: visible href is the verified collection URL when known; otherwise safe Shopify search.
      finalHref = verifiedCollectionUrl(h) || nativeSearchUrl(title || desc || 'rv parts');
      if(h){ extra = ' data-yf-dd-collection="1" data-handle="'+esc(h)+'" data-fallback-q="'+esc(title || desc || 'rv parts')+'"'; }
    }
    return '<a class="yf-dd-item"'+extra+' href="'+esc(finalHref)+'"><span class="yf-badge '+esc(type)+'">'+esc(type==='collection'?'Category':type.charAt(0).toUpperCase()+type.slice(1))+'</span><span><strong>'+esc(title)+'</strong><small>'+esc(desc||'')+'</small></span></a>';
  }
  function ddGroup(title, body){ return body ? '<div class="yf-dd-group"><div class="yf-dd-head">'+esc(title)+'</div>'+body+'</div>' : ''; }

  function bindDropdownCollectionSafety(root){
    if(!root) return;
    root.querySelectorAll('[data-yf-dd-collection]').forEach(a => {
      if(a.dataset.safeBound) return;
      a.dataset.safeBound = '1';
      a.addEventListener('click', async e => {
        const h = canonicalCollectionHandle(a.getAttribute('data-handle') || '');
        if(!h) return;
        e.preventDefault();
        // Never send a customer to a guessed /collections URL. Resolve via Shopify's own
        // collection suggestions first, then fall back to confirmed handle or native search.
        location.href = await resolveCollectionUrl(h, a.getAttribute('data-fallback-q') || a.textContent || h);
      });
    });
  }

  async function searchDD(root,q){
    const dd = root.querySelector('[data-yf-dd]'); if(!dd) return; if(q.length < 2){ dd.hidden = true; return; }
    const numberTokens = partOrModelCandidateTokens(q);
    const [exactSku, exactPart, exactModel] = await Promise.all([db.sku(q), bestPartForQuery(q), bestModelForQuery(q)]);
    let parts = [], models = [];
    if(numberTokens.length){
      const prefixJobs = numberTokens.slice(0,4).map(c => Promise.all([db.searchPrefix('part',c,3), db.searchPrefix('model',c,3)]));
      const prefixResults = await Promise.all(prefixJobs);
      prefixResults.forEach(([pp,mm]) => { parts = parts.concat(pp || []); models = models.concat(mm || []); });
    }
    const collection = await primaryCollection(q, exactModel, exactPart);
    const ddCollections = await collectionsForQuery(q, exactModel, exactPart, collection);
    let html = '';
    if(exactSku && exactSku.length){ html += ddGroup('Exact SKU match', exactSku.slice(0,3).map(p => ddItem('sku', p.sku, [p.title, p.inventory != null ? p.inventory + ' in stock' : ''].filter(Boolean).join(' • '), nativeSearchUrl(p.sku)+'&yf_force=sku')).join('')); }
    let partList = []; if(exactPart) partList.push(exactPart); parts.forEach(p => { if(p && !partList.find(x => x.p === p.p)) partList.push(p); });
    let modelList = []; if(exactModel) modelList.push(exactModel); models.forEach(m => { if(m && !modelList.find(x => x.m === m.m)) modelList.push(m); });
    html += ddGroup('Part number matches', partList.slice(0,5).map(p => ddItem('part', p.p, [p.d, p.fits ? 'Fits '+p.fits+' models' : ''].filter(Boolean).join(' • '), nativeSearchUrl(p.p)+'&yf_force=part')).join(''));
    html += ddGroup('Model number matches', modelList.slice(0,5).map(m => ddItem('model', m.m, [m.b, cleanCategoryName(m.c)].filter(Boolean).join(' • '), nativeSearchUrl(m.m)+'&yf_force=model')).join(''));
    html += ddCollections && ddCollections.length ? ddGroup(ddCollections.length > 1 ? 'Matching collections' : 'Best collection', ddCollections.slice(0,3).map(c => ddItem('collection', titleFromCollection(c), cleanCategoryName(c.categoryGroup || c.displayName || ''), collectionHref(c))).join('')) : '';
    html += '<div class="yf-dd-footer"><a href="'+nativeSearchUrl(q)+'">Search Shopify for “'+esc(q)+'”</a></div>';
    dd.innerHTML = html || '<div class="yf-empty-state small">Press Enter to search Shopify.</div>'; dd.hidden = false; bindDropdownCollectionSafety(dd);
  }
  function initSearch(root){
    const f = root.querySelector('form'), input = root.querySelector('[data-yf-search-input]'), dd = root.querySelector('[data-yf-dd]'); if(!f || !input || root.dataset.bound) return; root.dataset.bound = '1';
    f.addEventListener('submit', e => { e.preventDefault(); const q = input.value.trim(); if(q) location.href = nativeSearchUrl(q); });
    input.addEventListener('input', deb(() => searchDD(root, input.value.trim()), 220));
    input.addEventListener('focus', () => { const q = input.value.trim(); if(q.length >= 2) searchDD(root,q); });
    document.addEventListener('click', e => { if(dd && !root.contains(e.target)) dd.hidden = true; });
  }
  async function initModelAccordions(scope){
    scope.querySelectorAll('[data-yf-model-details]').forEach(el => { const details = el.closest('details'); if(!details || details.dataset.bound) return; details.dataset.bound = '1'; details.addEventListener('toggle', async () => { if(!details.open || el.dataset.loaded) return; el.dataset.loaded = '1'; const m = await db.model(el.dataset.model); if(!m){ el.innerHTML = '<p>No model details found.</p>'; return; } const di = (m.diagrams || [])[0]; const products = await productsForParts((m.parts || []).slice(0,40), 4, {expectedBrands:[m.b], expectedCategory:m.c}); el.innerHTML = '<div class="yf-model-detail"><p><strong>'+esc(m.m)+'</strong> • '+esc([m.b,cleanCategoryName(m.c)].filter(Boolean).join(' • '))+'</p>'+(products.length?'<div class="yf-mini-products">'+products.map(p=>productCard(p)).join('')+'</div>':'')+(di?'<a class="yf-btn small" href="'+diagramUrl(di.id)+'">View full diagram</a>':'')+'</div>'; hydrateProducts(el); }); });
  }
  async function initProductWidgets(){
    document.querySelectorAll('[data-yf-product-compat]').forEach(async root => {
      if(root.dataset.bound) return;
      root.dataset.bound = '1';
      const lookupNo = root.dataset.part || root.dataset.sku;
      root.hidden = true;
      if(!lookupNo){ root.innerHTML = ''; return; }

      // Product-page compatibility has two modes:
      // 1) If the extracted number is a model number, show the same model-match experience
      //    customers see in native search, but without the recommended collection block.
      // 2) If the extracted number is a part number, show only the Fits these models grid.
      // Check model first so complete units using model numbers do not get hidden as non-part matches.
      let model = await db.model(lookupNo);
      if(!model){
        const possiblePart = await db.part(lookupNo);
        if(!possiblePart){
          model = await bestModelForQuery(lookupNo);
        }
      }
      if(model){
        model._allDiagrams = await allDiagramSummariesForModel(model);
        const serialAware = modelHasSerialHierarchy(model);
        const completeId = 'yf-product-compat-complete-products-' + norm(lookupNo);
        const partsId = 'yf-product-compat-model-products-' + norm(lookupNo);
        let html = '<div class="yf-product-model-match-widget">' + modelIntro(model, serialAware);
        if(serialAware){
          html += serialPickerHtml(model);
          html += '<section class="yf-panel yf-soft"><h2>Choose a serial before we show parts</h2><p>This model has serial-specific breakdowns. We hide complete units, replacement parts, and diagram choices until a serial is selected so customers do not buy parts from the wrong production run.</p></section>';
        }else{
          html += breakdownPreview(model);
          html += productPlaceholder(completeId, 'Complete units', '');
          html += productPlaceholder(partsId, 'Available replacement parts for this model', '');
        }
        html += '</div>';
        root.hidden = false;
        root.innerHTML = html;
        initSerialSelectors(root);
        bindDiagramInteractions(root);
        hydrateProducts(root).catch(function(){});
        if(!serialAware){
          lazyLoadModelProducts(root, model, lookupNo, {
            currentHandle: root.dataset.handle || '',
            completePanelId: completeId,
            modelPanelId: partsId
          });
        }
        return;
      }

      const part = await db.part(lookupNo);
      if(part){
        const seenModels = new Set();
        const compatibleModels = (part.used || []).filter(u => {
          const k = norm(u && u[0]);
          if(!k || seenModels.has(k)) return false;
          seenModels.add(k);
          return true;
        }).slice(0,180);
        if(!compatibleModels.length){ root.hidden = true; root.innerHTML = ''; return; }
        root.hidden = false;
        root.innerHTML = '<section class="yf-panel yf-product-compat-box yf-product-compat-models-only"><h2>Fits these models</h2><p class="yf-product-compat-subheading">Click your model number to view complete units, part breakdowns and all available parts for your model</p><div class="yf-model-list yf-compat-model-grid">'
          + compatibleModels.map(u => '<a class="yf-model-link" href="'+nativeSearchUrl(u[0])+'&yf_force=model"><strong>'+esc(u[0])+'</strong></a>').join('')
          + '</div></section>';
        return;
      }
      root.hidden = true;
      root.innerHTML = '';
    });
  }
  // V21: category breakdown selector is a true cascade: manufacturer -> series only when needed -> model -> serial only when needed.
  // It also parses raw database brand values like "Flojet Fresh Water" into Manufacturer="Flojet" and Series="Fresh Water".
  const YF_MANUFACTURER_NAMES = [
    'Lippert Components','Aqua-Hot','Duo-Therm','Suburban','Dometic','Atwood','Flojet','Jabsco','SHURflo','Shurflo','Remco','Thetford','WFCO','Norcold','Coleman','Carefree','Furrion','Dexter','Camco','Valterra','Sealand','Marshall Excelsior'
  ];
  function tidyLabel(v){ return String(v || '').replace(/\u00A0/g,' ').replace(/\s+/g,' ').trim(); }
  function titleCaseSmart(v){
    let s = tidyLabel(v);
    const fixes = {'shurflo':'SHURflo','wfco':'WFCO','aqua-hot':'Aqua-Hot','duo-therm':'Duo-Therm','rv':'RV','nt':'NT','sf':'SF','rm':'RM'};
    return s.split(' ').map(w => fixes[w.toLowerCase()] || (w ? w[0].toUpperCase()+w.slice(1) : w)).join(' ');
  }
  function parseCategoryManufacturer(raw){
    const original = tidyLabel(raw);
    const upper = original.toUpperCase();
    for(const known of YF_MANUFACTURER_NAMES.sort((a,b)=>b.length-a.length)){
      const ku = known.toUpperCase();
      if(upper === ku || upper.startsWith(ku + ' ')){
        return {manufacturer:titleCaseSmart(known), parsedSeries:tidyLabel(original.slice(known.length))};
      }
    }
    const words = original.split(' ').filter(Boolean);
    return {manufacturer:titleCaseSmart(words.shift() || original), parsedSeries:tidyLabel(words.join(' '))};
  }
  function displaySeriesName(parsedSeries, dbSeries){
    const ps = tidyLabel(parsedSeries);
    const ds = tidyLabel(dbSeries);
    if(!ps && (!ds || /^other$/i.test(ds))) return 'All models';
    if(ps && (!ds || /^other$/i.test(ds))) return ps;
    if(!ps) return titleCaseSmart(ds);
    if(norm(ps) === norm(ds) || norm(ps).includes(norm(ds)) || norm(ds).includes(norm(ps))) return ps;
    return ps + ' · ' + ds;
  }
  function selectorContextFrom(root, c){
    const params = new URLSearchParams(location.search);
    return plain([
      root && root.dataset && root.dataset.categoryQuery,
      params.get('q'),
      c && c.collectionHandle,
      c && c.displayName,
      c && c.category,
      location.pathname
    ].filter(Boolean).join(' '));
  }
  function selectorFamilyFilter(root, c){
    const ctx = selectorContextFrom(root, c);
    const handle = plain(c && c.collectionHandle || '');
    const display = plain(c && c.displayName || '');
    const category = plain(c && c.category || '');
    const rule = referringRuleForQuery([ctx, handle, display, category].filter(Boolean).join(' '));
    const allow = new Set((rule && rule.selectorAllow || []).map(plain).filter(Boolean));
    const block = new Set((rule && rule.selectorBlock || []).map(plain).filter(Boolean));

    // Extra safety for categories that share a broad database category but are different real customer intents.
    if(handle.includes('pompes') || display.includes('water pump') || ctx.includes('water pump') || ctx === 'pump' || ctx === 'pumps'){
      ['vacuum','central vacuum','dometic vacuum'].forEach(x=>block.add(x));
      ['fresh water','waste water','water pump','flojet','jabsco','shurflo','shur flo','remco','thetford','wfco','lippert'].forEach(x=>allow.add(x));
    }
    if(handle.includes('vacuum') || display.includes('vacuum') || ctx.includes('vacuum')){
      allow.clear(); ['vacuum','central vacuum','dirt devil','dometic vacuum'].forEach(x=>allow.add(x));
      ['fresh water','waste water','water pump','pump fitting'].forEach(x=>block.add(x));
    }

    return function(rec){
      const hay = plain([rec.rawBrand, rec.rawSeries, rec.seriesName, rec.manufacturer, rec.modelNumber, category, display].join(' '));
      for(const b of block){ if(b && hay.includes(b)) return false; }
      if(allow.size){
        for(const a of allow){ if(a && hay.includes(a)) return true; }
        // Let exact non-mixed database categories through when no detailed family token is in the raw brand.
        if(category && !['pumps'].includes(category)) return true;
        return false;
      }
      return true;
    };
  }
  function collapseSingleMeaningSeries(seriesMap){
    const keys = Object.keys(seriesMap || {});
    if(keys.length === 1) return seriesMap;
    const nonUseful = keys.filter(k => ['all models','other',''].includes(plain(k)));
    if(nonUseful.length && keys.length === 2){
      const useful = keys.find(k => !nonUseful.includes(k));
      if(useful){
        nonUseful.forEach(k => {
          seriesMap[useful] = (seriesMap[useful] || []).concat(seriesMap[k] || []);
          delete seriesMap[k];
        });
      }
    }
    return seriesMap;
  }

  // V53: Some furnace selector rows store a series shell as the "model" and the real
  // model numbers inside serials. Example: Suburban SF Series -> model "SF Series"
  // -> serials ["SF20","SF25","SF30"]. For customers, SF20/SF25/SF30 are model
  // choices, not serial choices. Flatten these shell records so the selector flow
  // becomes Manufacturer -> Series -> Model, with no duplicate series/model step.
  function isSeriesShellModelRecord(rec){
    const model = tidyLabel(rec && rec.modelNumber);
    const serials = (rec && rec.serials) || [];
    if(!model || !/series$/i.test(model) || !serials.length) return false;
    return serials.some(x => /[0-9]/.test(String(x || '')));
  }
  function expandSeriesShellModelRecord(rec){
    if(!isSeriesShellModelRecord(rec)) return [rec];
    return (rec.serials || []).filter(Boolean).map(serialModel => Object.assign({}, rec, {
      modelNumber: String(serialModel),
      normalized: norm(serialModel),
      serials: [],
      _seriesShellModel: rec.modelNumber,
      _seriesShellExpanded: true
    }));
  }
  function buildCategoryCascade(c, root){
    const out = {manufacturers:{}};
    const allowRecord = selectorFamilyFilter(root, c || {});
    const strictCtx = plain([root && root.dataset && root.dataset.categoryQuery, c && c.collectionHandle, c && c.displayName, c && c.category].filter(Boolean).join(' '));
    const isWaterPumpIntent = strictCtx.includes('water pump') || strictCtx.includes('pompes') || strictCtx.includes('used water pump') || (strictCtx.includes('pump') && !strictCtx.includes('vacuum'));
    const isVacuumIntent = strictCtx.includes('vacuum');
    const awningChoice = plain(root && root.dataset && root.dataset.yfAwningBreakdownCategory || '');
    const isAwningSelector = plain([c && c.category, c && c.displayName, c && c.collectionHandle, root && root.dataset && root.dataset.categoryQuery].filter(Boolean).join(' ')).includes('awning');
    function awningRecordType(rawBrand, dbSeries, rec){
      const hay = plain([rawBrand, dbSeries, rec && rec.seriesName, rec && rec.modelNumber, rec && rec.rawSeries].filter(Boolean).join(' '));
      const hardwareish = /hardware|anti flap|anti-flap|rafter|arm|arms|bracket|support|cradle|knob|roller|torsion|spring|end cap|cap kit|mount|mounting|rail|track|motor|switch|control|sensor|center rafter|rafters/.test(hay);
      return hardwareish ? 'awning-hardware' : 'awnings';
    }
    Object.entries(c && c.manufacturers || {}).forEach(([rawBrand, raw]) => {
      const rawHay = plain([rawBrand, JSON.stringify(raw || {})].join(' '));
      // V30 hard guard: broad DB category "Pumps" contains both water pumps and central vacuums.
      // Water-pump selectors must never show vacuum brands/series/models, even if older cached data still contains them.
      if(isWaterPumpIntent && rawHay.includes('vacuum')) return;
      if(isVacuumIntent && !rawHay.includes('vacuum') && !rawHay.includes('dirt devil')) return;
      const parsed = parseCategoryManufacturer(rawBrand);
      const manufacturer = parsed.manufacturer || rawBrand;
      Object.entries(raw.series || {}).forEach(([dbSeries, models]) => {
        const seriesName = displaySeriesName(parsed.parsedSeries, dbSeries);
        (models || []).forEach(m => {
          const baseRec = Object.assign({}, m, {manufacturer, seriesName, rawBrand, rawSeries:dbSeries});
          expandSeriesShellModelRecord(baseRec).forEach(rec => {
            if(isAwningSelector && awningChoice){
              const recType = awningRecordType(rawBrand, dbSeries, rec);
              if(awningChoice === 'awning-hardware' && recType !== 'awning-hardware') return;
              if(awningChoice === 'awnings' && recType !== 'awnings') return;
            }
            if(!allowRecord(rec)) return;
            const mf = out.manufacturers[manufacturer] || (out.manufacturers[manufacturer] = {series:{}, count:0});
            const list = mf.series[seriesName] || (mf.series[seriesName] = []);
            if(!list.some(x => norm(x.modelNumber) === norm(rec.modelNumber) && JSON.stringify(x.serials||[]) === JSON.stringify(rec.serials||[]))) list.push(rec);
          });
        });
      });
    });
    Object.values(out.manufacturers).forEach(mf => {
      mf.series = collapseSingleMeaningSeries(mf.series);
      Object.keys(mf.series).forEach(k => { mf.series[k].sort((a,b)=>String(a.modelNumber).localeCompare(String(b.modelNumber), undefined, {numeric:true})); mf.count += mf.series[k].length; });
    });
    return out;
  }
  function showCascadeStep(step, show){ if(step){ step.hidden = !show; step.classList.toggle('active', !!show); } }
  function categoryWidgetRecord(idx, root, handle, title){
    const query = String(root && root.dataset && root.dataset.categoryQuery || '');
    const hay = plain([handle, title, query].filter(Boolean).join(' '));
    const templateMap = [
      [/air[- ]?condition|a\/?c|air-conditioners/i, 'new-used-rv-air-conditioners-replacement-parts'],
      [/awning|awning-hardware/i, 'mouldings'],
      [/furnace|used-furnaces/i, 'new-used-rv-furnaces-replacement-parts'],
      [/refrigerator|fridge|refrigerators/i, 'new-used-rv-refrigerators-replacement-parts'],
      [/water[- ]?heater|hot[- ]?water/i, 'new-used-rv-hot-water-heaters'],
      [/oven|range|stove|ovens/i, 'new-rv-ranges-ovens-range-hoods-replacement-parts']
    ];
    if(idx[handle]) return idx[handle];
    for(const pair of templateMap){ if(pair[0].test([handle,title,query].join(' ')) && idx[pair[1]]) return idx[pair[1]]; }
    return Object.values(idx).find(x => {
      const display = norm(x.displayName || x.category || '');
      const category = norm(x.category || '');
      const q = norm(query);
      const t = norm(title);
      return (display && (display.includes(t) || t.includes(display) || display.includes(q) || q.includes(display))) ||
             (category && (category.includes(t) || t.includes(category) || category.includes(q) || q.includes(category)));
    });
  }
  async function initCategoryWidgets(){
    document.querySelectorAll('[data-yf-category-widget]').forEach(async root => {
      if(root.dataset.bound) return;
      root.dataset.bound = '1';
      const silent = String(root.dataset.yfSilent || '').toLowerCase() === 'true';
      const idx = await db.categoryModels();
      const handle = root.dataset.collectionHandle || '';
      const title = root.dataset.collectionTitle || '';
      const c = categoryWidgetRecord(idx, root, handle, title);
      if(!c){ root.innerHTML = ''; return; }

      const widgetTitle = cleanCategoryName(c.category || c.displayName || title || 'this category');
      const isAwningWidget = plain([c.category, c.displayName, handle, title, root.dataset.categoryQuery].filter(Boolean).join(' ')).includes('awning');
      if(isAwningWidget && !root.dataset.yfAwningBreakdownCategory){ root.dataset.yfAwningBreakdownCategory = ''; }
      let cascade = buildCategoryCascade(c, root);
      let brands = Object.keys(cascade.manufacturers || {}).sort((a,b)=>a.localeCompare(b));
      if(!brands.length && !isAwningWidget){ root.innerHTML = silent ? '' : '<section class="yf-panel yf-category-widget"><h2>No model breakdowns found for this exact category</h2><p>Use the matching collection links above or try a broader search.</p></section>'; return; }
      const headCount = isAwningWidget && !root.dataset.yfAwningBreakdownCategory ? '2 types' : esc(brands.length)+' brands';
      root.innerHTML = '<section class="yf-panel yf-category-widget yf-cascade-widget"><div class="yf-panel-head"><div><h2>Find parts breakdowns for your '+esc(widgetTitle)+'</h2><p>Choose one step at a time. We only show the next choice when it is needed for this category.</p></div><strong data-yf-cat-count>'+headCount+'</strong></div>'
        + '<div class="yf-cascade-steps">'
        + (isAwningWidget ? '<div class="yf-cascade-step active" data-yf-step="awning-type"><label>Category<select data-yf-cat-awning-type><option value="">Select category</option><option value="awnings">Awnings</option><option value="awning-hardware">Awning Hardware</option></select></label></div>' : '')
        + '<div class="yf-cascade-step '+(isAwningWidget && !root.dataset.yfAwningBreakdownCategory ? '' : 'active')+'" data-yf-step="brand" '+(isAwningWidget && !root.dataset.yfAwningBreakdownCategory ? 'hidden' : '')+'><label>Manufacturer<select data-yf-cat-brand><option value="">Select manufacturer</option>'+brands.map(b=>'<option value="'+esc(b)+'">'+esc(b)+'</option>').join('')+'</select></label></div>'
        + '<div class="yf-cascade-step" data-yf-step="series" hidden><label>Series<select data-yf-cat-series><option value="">Choose series</option></select></label></div>'
        + '<div class="yf-cascade-step" data-yf-step="model" hidden><label>Model Number<select data-yf-cat-model><option value="">Choose model</option></select></label></div>'
        + '<div class="yf-cascade-step" data-yf-step="serial" hidden><label>Serial / production range<select data-yf-cat-serial><option value="">All serials / not sure</option></select></label></div>'
        + '</div><button class="yf-btn" data-yf-cat-go disabled>View breakdown</button></section>';

      const awningTypeSel=root.querySelector('[data-yf-cat-awning-type]'), brandSel=root.querySelector('[data-yf-cat-brand]'), seriesSel=root.querySelector('[data-yf-cat-series]'), modelSel=root.querySelector('[data-yf-cat-model]'), serialSel=root.querySelector('[data-yf-cat-serial]'), go=root.querySelector('[data-yf-cat-go]');
      const countEl=root.querySelector('[data-yf-cat-count]'), brandStep=root.querySelector('[data-yf-step="brand"]'), seriesStep=root.querySelector('[data-yf-step="series"]'), modelStep=root.querySelector('[data-yf-step="model"]'), serialStep=root.querySelector('[data-yf-step="serial"]');
      let selectedModels=[];
      function rebuildBrandChoices(){
        cascade = buildCategoryCascade(c, root);
        brands = Object.keys(cascade.manufacturers || {}).sort((a,b)=>a.localeCompare(b));
        brandSel.innerHTML = '<option value="">Select manufacturer</option>'+brands.map(b=>'<option value="'+esc(b)+'">'+esc(b)+'</option>').join('');
        if(countEl) countEl.textContent = brands.length + ' brands';
        showCascadeStep(brandStep, !!brands.length);
      }
      function resetBelow(level){
        if(level <= 1){ seriesSel.innerHTML='<option value="">Choose series</option>'; showCascadeStep(seriesStep,false); }
        if(level <= 2){ modelSel.innerHTML='<option value="">Choose model</option>'; showCascadeStep(modelStep,false); selectedModels=[]; }
        if(level <= 3){ serialSel.innerHTML='<option value="">All serials / not sure</option>'; showCascadeStep(serialStep,false); }
        go.disabled = true;
      }
      function showModels(models){
        selectedModels = (models || []).slice().sort((a,b)=>String(a.modelNumber).localeCompare(String(b.modelNumber), undefined, {numeric:true}));
        modelSel.innerHTML='<option value="">Choose model</option>'+selectedModels.map(m=>'<option value="'+esc(m.modelNumber)+'">'+esc(m.modelNumber)+'</option>').join('');
        showCascadeStep(modelStep,true);
      }
      if(awningTypeSel){
        awningTypeSel.addEventListener('change',()=>{
          root.dataset.yfAwningBreakdownCategory = awningTypeSel.value || '';
          resetBelow(1);
          if(!awningTypeSel.value){
            if(countEl) countEl.textContent = '2 types';
            showCascadeStep(brandStep, false);
            return;
          }
          rebuildBrandChoices();
        });
      }
      brandSel.addEventListener('change',()=>{
        resetBelow(1);
        const b = cascade.manufacturers[brandSel.value];
        if(!b) return;
        const series = Object.keys(b.series || {}).sort((a,b)=>a.localeCompare(b));
        if(series.length > 1){
          seriesSel.innerHTML = '<option value="">Choose series</option>'+series.map(s=>'<option value="'+esc(s)+'">'+esc(s)+'</option>').join('');
          showCascadeStep(seriesStep,true);
        }else{
          showModels(b.series[series[0]] || []);
        }
      });
      seriesSel.addEventListener('change',()=>{
        resetBelow(2);
        const b = cascade.manufacturers[brandSel.value];
        if(!b || !seriesSel.value) return;
        showModels(b.series[seriesSel.value] || []);
      });
      modelSel.addEventListener('change',()=>{
        resetBelow(3);
        const m = selectedModels.find(x=>x.modelNumber===modelSel.value);
        if(!m){ go.disabled=true; return; }
        const serials=(m.serials||[]).filter(Boolean).sort((a,b)=>String(a).localeCompare(String(b), undefined, {numeric:true}));
        if(serials.length){
          serialSel.innerHTML='<option value="">All serials / not sure</option>'+serials.map(s=>'<option value="'+esc(s)+'">'+esc(s)+'</option>').join('');
          showCascadeStep(serialStep,true);
        }
        go.disabled = false;
      });
      serialSel.addEventListener('change',()=>{ go.disabled = !modelSel.value; });
      go.addEventListener('click',()=>{ if(!modelSel.value)return; location.href = modelBreakdownUrl(modelSel.value)+(serialSel.value?'&serial='+enc(serialSel.value):''); });
    });
  }
  function hideShopifyNativeSearchSections(root){
    try{
      const section = root && root.closest && root.closest('.shopify-section');
      if(!section) return;
      let hidden = 0;
      let node = section.nextElementSibling;
      while(node && hidden < 2){
        if(node.classList && node.classList.contains('shopify-section')){
          const txt = (node.textContent || '').trim();
          if(/Search/i.test(txt) || node.id && /search/i.test(node.id)){
            node.style.display = 'none';
            node.setAttribute('data-yf-hidden-native-search','true');
            hidden++;
          }
        }
        node = node.nextElementSibling;
      }
      document.body.classList.add('yf-breakdown-mode');
    }catch(e){}
  }
  function boot(){
    document.querySelectorAll('[data-yf-native-search]').forEach(initSearch);
    document.querySelectorAll('[data-yf-native-app]').forEach(root => {
      if(root.dataset.appBound) return;
      root.dataset.appBound = '1';
      const params = new URLSearchParams(location.search);
      const type = params.get('yf_mode') || root.dataset.pageType;
      const form = root.querySelector('[data-yf-page-search]');
      if(form) form.addEventListener('submit', e => { e.preventDefault(); saveNativePageCache(root, false); const q = form.querySelector('input[name="q"]').value.trim(); if(q) location.href = nativeSearchUrl(q); });
      if(type === 'breakdowns') hideShopifyNativeSearchSections(root);
      if(restoreNativePageCache(root, type)) return;
      if(type === 'page-model-match'){
        const autoQ = pageModelQueryFromHandle(root.getAttribute('data-yf-page-handle') || '');
        if(!autoQ){ if(root && root.remove) root.remove(); return; }
        renderSearch(root, autoQ, {modelOnly:true, removeWhenNoModel:true});
        return;
      }
      if(type === 'part-search') renderSearch(root, params.get('q') || '');
      if(type === 'part-number') renderPart(root, params.get('id') || params.get('part') || params.get('q') || '');
      if(type === 'breakdowns') renderBreakdown(root, params);
      if(type === 'image-search'){
        const res = root.querySelector('[data-yf-results]');
        if(res){
          res.innerHTML = '<section class="yf-panel"><h2>Image Search</h2><p>Image recognition still needs a secure backend for AI keys. Model, part, compatibility, and diagram lookup are native inside this Shopify theme.</p><a class="yf-btn" href="/search">Search by part or model</a></section>';
          scheduleNativePageCacheSave(res, false);
        }
      }
    });
    initProductWidgets(); initProductPartInfoWidgets(); initCategoryWidgets();
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
  window.addEventListener('pagehide', function(){ saveNativePageCache(document.querySelector('[data-yf-native-app]'), false); });
  document.addEventListener('click', function(e){
    const target = e.target && e.target.closest && e.target.closest('a[href], button, [role="button"]');
    if(target) saveNativePageCache(document.querySelector('[data-yf-native-app]'), false);
  }, true);


  // V39: capture smart collection clicks before the browser can visit a bad guessed handle.
  document.addEventListener('click', async function(e){
    const a = e.target && e.target.closest && e.target.closest('[data-yf-collection-card], [data-yf-dd-collection]');
    if(!a) return;
    const h = canonicalCollectionHandle(a.getAttribute('data-handle') || '');
    const fallback = a.getAttribute('data-fallback-q') || (a.querySelector && a.querySelector('h3') && a.querySelector('h3').textContent) || a.textContent || h;
    if(!h) return;
    e.preventDefault();
    location.href = await resolveCollectionUrl(h, fallback);
  }, true);

  // V38 defensive cleanup: never show old "No exact database match found" smart-panel cards.
  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('.yf-empty-state, .yf-panel, section, div').forEach(function(el){
      try{
        if(/No exact database match found/i.test(el.textContent || '')) el.remove();
      }catch(e){}
    });
  });

})();
